/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createArchivedDiscrepancy = /* GraphQL */ `mutation CreateArchivedDiscrepancy(
  $condition: ModelArchivedDiscrepancyConditionInput
  $input: CreateArchivedDiscrepancyInput!
) {
  createArchivedDiscrepancy(condition: $condition, input: $input) {
    archivedDate
    companyId
    createdAt
    downReason
    equipmentId
    equipmentName
    id
    initialStatus
    log
    owner
    promptDescription
    promptLabel
    promptTitle
    questionIndex
    reportId
    status
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateArchivedDiscrepancyMutationVariables,
  APITypes.CreateArchivedDiscrepancyMutation
>;
export const createAuditLog = /* GraphQL */ `mutation CreateAuditLog(
  $condition: ModelAuditLogConditionInput
  $input: CreateAuditLogInput!
) {
  createAuditLog(condition: $condition, input: $input) {
    action
    companyId
    createdAt
    details
    id
    resourceId
    resourceName
    resourceType
    ttl
    updatedAt
    userId
    userName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAuditLogMutationVariables,
  APITypes.CreateAuditLogMutation
>;
export const createAxleBlueprint = /* GraphQL */ `mutation CreateAxleBlueprint(
  $condition: ModelAxleBlueprintConditionInput
  $input: CreateAxleBlueprintInput!
) {
  createAxleBlueprint(condition: $condition, input: $input) {
    axles
    centerlineLength
    companyId
    createdAt
    description
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAxleBlueprintMutationVariables,
  APITypes.CreateAxleBlueprintMutation
>;
export const createBillingRate = /* GraphQL */ `mutation CreateBillingRate(
  $condition: ModelBillingRateConditionInput
  $input: CreateBillingRateInput!
) {
  createBillingRate(condition: $condition, input: $input) {
    companyId
    createdAt
    id
    owner
    ratePerCostTracking
    ratePerEquipment
    ratePerPM
    ratePerSafetyEnrollment
    ratePerSkillQualification
    ratePerTireMaint
    ratePerUser
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBillingRateMutationVariables,
  APITypes.CreateBillingRateMutation
>;
export const createBusinessAdmin = /* GraphQL */ `mutation CreateBusinessAdmin(
  $condition: ModelBusinessAdminConditionInput
  $input: CreateBusinessAdminInput!
) {
  createBusinessAdmin(condition: $condition, input: $input) {
    cognitoId
    createdAt
    domain
    email
    id
    name
    owner
    permissions
    role
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBusinessAdminMutationVariables,
  APITypes.CreateBusinessAdminMutation
>;
export const createChangeLogEntry = /* GraphQL */ `mutation CreateChangeLogEntry(
  $condition: ModelChangeLogEntryConditionInput
  $input: CreateChangeLogEntryInput!
) {
  createChangeLogEntry(condition: $condition, input: $input) {
    changedBy
    changedByName
    companyId
    createdAt
    description
    fieldName
    id
    newValue
    oldValue
    owner
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateChangeLogEntryMutationVariables,
  APITypes.CreateChangeLogEntryMutation
>;
export const createClassification = /* GraphQL */ `mutation CreateClassification(
  $condition: ModelClassificationConditionInput
  $input: CreateClassificationInput!
) {
  createClassification(condition: $condition, input: $input) {
    companyId
    createdAt
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateClassificationMutationVariables,
  APITypes.CreateClassificationMutation
>;
export const createCompany = /* GraphQL */ `mutation CreateCompany(
  $condition: ModelCompanyConditionInput
  $input: CreateCompanyInput!
) {
  createCompany(condition: $condition, input: $input) {
    accountNumber
    accountOrigin
    accountStatus
    addOnGracePeriodEndDate
    archived
    assignedRep
    billingAnchorDay
    billingContactAddress
    billingContactEmail
    billingContactName
    billingContactPhone
    billingCycle
    businessType
    cancelEffectiveDate
    cancelReason
    cancelReasonNote
    cancelRequestedAt
    companyOwnerId
    coreMonthlyRate
    costTrackingModuleEnrollment
    createdAt
    dataRetentionEndDate
    description
    gracePeriodEndDate
    id
    industryNAICS
    industrySIC
    initialContactDate
    initialStarterPackageEnrollment
    logo
    maxNumberEquipment
    maxNumberUsers
    name
    nextBillingDate
    notes
    numberOfUsers
    paidStartDate
    paymentFailedAt
    paymentMethod
    pmModuleEnrollment
    primaryContactEmail
    primaryContactName
    primaryContactPhone
    primaryContactPosition
    primaryLocation
    referredBy
    retryAttempts
    safetyComplianceStandard
    secondaryContactEmail
    secondaryContactName
    secondaryContactPhone
    secondaryContactPosition
    skillTrackingModuleEnrollment
    starterPackage
    status
    subscriptionExpiration
    subscriptionType
    tiresModuleEnrollment
    trainingModuleEnrollment
    trialEndDate
    trialStartDate
    type
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCompanyMutationVariables,
  APITypes.CreateCompanyMutation
>;
export const createCompanyNote = /* GraphQL */ `mutation CreateCompanyNote(
  $condition: ModelCompanyNoteConditionInput
  $input: CreateCompanyNoteInput!
) {
  createCompanyNote(condition: $condition, input: $input) {
    authorName
    companyId
    content
    createdAt
    id
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCompanyNoteMutationVariables,
  APITypes.CreateCompanyNoteMutation
>;
export const createCompanyOwner = /* GraphQL */ `mutation CreateCompanyOwner(
  $condition: ModelCompanyOwnerConditionInput
  $input: CreateCompanyOwnerInput!
) {
  createCompanyOwner(condition: $condition, input: $input) {
    cognitoId
    companyId
    contactPhoneNumber
    createdAt
    discrepancyNotification
    discrepancyNotificationTypes
    domain
    email
    id
    name
    owner
    permissions
    pmNotification
    pmNotificationTypes
    role
    siteAdmin
    subscriptionType
    trainingNotification
    trainingNotificationTypes
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCompanyOwnerMutationVariables,
  APITypes.CreateCompanyOwnerMutation
>;
export const createCompanyResource = /* GraphQL */ `mutation CreateCompanyResource(
  $condition: ModelCompanyResourceConditionInput
  $input: CreateCompanyResourceInput!
) {
  createCompanyResource(condition: $condition, input: $input) {
    category
    companyId
    contentFilePath
    contentUrl
    createdAt
    description
    fileType
    folderName
    id
    owner
    title
    trainingTopicId
    updatedAt
    uploadedByUserId
    uploadedByUserName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCompanyResourceMutationVariables,
  APITypes.CreateCompanyResourceMutation
>;
export const createDOTInspectionReport = /* GraphQL */ `mutation CreateDOTInspectionReport(
  $condition: ModelDOTInspectionReportConditionInput
  $input: CreateDOTInspectionReportInput!
) {
  createDOTInspectionReport(condition: $condition, input: $input) {
    companyId
    complianceStatus
    createdAt
    dotInspectionType
    equipmentCategoryId
    equipmentCategoryName
    expirationDate
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    inspectorCertificationId
    locationId
    okCount
    photos
    regulatoryStandard
    responseData
    signature
    totalItems
    unitId
    unitName
    updatedAt
    userId
    userName
    vehicleLicensePlate
    vehicleVIN
    warnCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDOTInspectionReportMutationVariables,
  APITypes.CreateDOTInspectionReportMutation
>;
export const createDailyServiceReport = /* GraphQL */ `mutation CreateDailyServiceReport(
  $condition: ModelDailyServiceReportConditionInput
  $input: CreateDailyServiceReportInput!
) {
  createDailyServiceReport(condition: $condition, input: $input) {
    alwaysTriggerEmail
    companyId
    createdAt
    dailyServiceLogFormId
    equipmentCategoryId
    equipmentCategoryName
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    locationId
    machineHoursAtService
    okCount
    photos
    responseData
    signature
    totalItems
    umCounterAtService
    unitId
    unitName
    updatedAt
    userId
    userName
    warnCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDailyServiceReportMutationVariables,
  APITypes.CreateDailyServiceReportMutation
>;
export const createDiscrepancy = /* GraphQL */ `mutation CreateDiscrepancy(
  $condition: ModelDiscrepancyConditionInput
  $input: CreateDiscrepancyInput!
) {
  createDiscrepancy(condition: $condition, input: $input) {
    companyId
    createdAt
    downReason
    equipmentId
    equipmentName
    id
    initialStatus
    log
    owner
    promptDescription
    promptLabel
    promptTitle
    questionIndex
    reportId
    status
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDiscrepancyMutationVariables,
  APITypes.CreateDiscrepancyMutation
>;
export const createDocument = /* GraphQL */ `mutation CreateDocument(
  $condition: ModelDocumentConditionInput
  $input: CreateDocumentInput!
) {
  createDocument(condition: $condition, input: $input) {
    assignedSafetyLesson
    contentPath
    createdAt
    folderName
    id
    owner
    resourceLibraryID
    safetyLesson
    sharedWithCompanyIds
    title
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDocumentMutationVariables,
  APITypes.CreateDocumentMutation
>;
export const createEquipment = /* GraphQL */ `mutation CreateEquipment(
  $condition: ModelEquipmentConditionInput
  $input: CreateEquipmentInput!
) {
  createEquipment(condition: $condition, input: $input) {
    companyId
    createdAt
    formId
    id
    image
    name
    units
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEquipmentMutationVariables,
  APITypes.CreateEquipmentMutation
>;
export const createEquipmentCategory = /* GraphQL */ `mutation CreateEquipmentCategory(
  $condition: ModelEquipmentCategoryConditionInput
  $input: CreateEquipmentCategoryInput!
) {
  createEquipmentCategory(condition: $condition, input: $input) {
    companyId
    createdAt
    formId
    id
    image
    name
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEquipmentCategoryMutationVariables,
  APITypes.CreateEquipmentCategoryMutation
>;
export const createErrors = /* GraphQL */ `mutation CreateErrors(
  $condition: ModelErrorsConditionInput
  $input: CreateErrorsInput!
) {
  createErrors(condition: $condition, input: $input) {
    createdAt
    errors
    id
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateErrorsMutationVariables,
  APITypes.CreateErrorsMutation
>;
export const createExpenseCategory = /* GraphQL */ `mutation CreateExpenseCategory(
  $condition: ModelExpenseCategoryConditionInput
  $input: CreateExpenseCategoryInput!
) {
  createExpenseCategory(condition: $condition, input: $input) {
    companyId
    createdAt
    id
    name
    owner
    startingBalance
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateExpenseCategoryMutationVariables,
  APITypes.CreateExpenseCategoryMutation
>;
export const createExpenseRecord = /* GraphQL */ `mutation CreateExpenseRecord(
  $condition: ModelExpenseRecordConditionInput
  $input: CreateExpenseRecordInput!
) {
  createExpenseRecord(condition: $condition, input: $input) {
    attachments
    companyId
    createdAt
    dateOfInput
    dateOfService
    equipmentCategoryId
    expenseCategories
    id
    invoiceNumber
    laborHoursOT
    laborHoursST
    laborRateOT
    laborRateST
    laborRateScheduleId
    laborRateScheduleName
    owner
    pmExpense
    pmServiceLevelId
    pmServiceLevelName
    totalExpense
    totalLaborCost
    unitId
    updatedAt
    vendorId
    vendorName
    workDescription
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateExpenseRecordMutationVariables,
  APITypes.CreateExpenseRecordMutation
>;
export const createForm = /* GraphQL */ `mutation CreateForm(
  $condition: ModelFormConditionInput
  $input: CreateFormInput!
) {
  createForm(condition: $condition, input: $input) {
    alwaysTriggerEmail
    companyId
    createdAt
    dailyServiceLogForm
    equipmentType
    formData
    formType
    id
    inspectionForm
    name
    noMachineHours
    noUMCounter
    owner
    pmServiceScheduleForm
    status
    umCounterLabel
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFormMutationVariables,
  APITypes.CreateFormMutation
>;
export const createFormTemplate = /* GraphQL */ `mutation CreateFormTemplate(
  $condition: ModelFormTemplateConditionInput
  $input: CreateFormTemplateInput!
) {
  createFormTemplate(condition: $condition, input: $input) {
    createdAt
    createdByCompanyOwnerId
    dailyServiceLogForm
    formTemplateGroupID
    id
    inspectionForm
    originalCompanyId
    owner
    pmServiceScheduleForm
    templateData
    templateName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFormTemplateMutationVariables,
  APITypes.CreateFormTemplateMutation
>;
export const createFormTemplateGroup = /* GraphQL */ `mutation CreateFormTemplateGroup(
  $condition: ModelFormTemplateGroupConditionInput
  $input: CreateFormTemplateGroupInput!
) {
  createFormTemplateGroup(condition: $condition, input: $input) {
    createdAt
    description
    id
    name
    owner
    resourceLibraryID
    sharedWithCompanyIds
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFormTemplateGroupMutationVariables,
  APITypes.CreateFormTemplateGroupMutation
>;
export const createHelpSupportDoc = /* GraphQL */ `mutation CreateHelpSupportDoc(
  $condition: ModelHelpSupportDocConditionInput
  $input: CreateHelpSupportDocInput!
) {
  createHelpSupportDoc(condition: $condition, input: $input) {
    contentFilePath
    contentUrl
    createdAt
    createdByAdminId
    description
    docType
    id
    owner
    sharedWithCompanyIds
    status
    title
    updatedAt
    visibility
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHelpSupportDocMutationVariables,
  APITypes.CreateHelpSupportDocMutation
>;
export const createInspectionReport = /* GraphQL */ `mutation CreateInspectionReport(
  $condition: ModelInspectionReportConditionInput
  $input: CreateInspectionReportInput!
) {
  createInspectionReport(condition: $condition, input: $input) {
    alwaysTriggerEmail
    companyId
    createdAt
    equipmentCategoryId
    equipmentCategoryName
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    locationId
    machineHoursAtInspection
    okCount
    photos
    responseData
    signature
    totalItems
    umCounterAtInspection
    unitId
    unitName
    updatedAt
    userId
    userName
    warnCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInspectionReportMutationVariables,
  APITypes.CreateInspectionReportMutation
>;
export const createInvoice = /* GraphQL */ `mutation CreateInvoice(
  $condition: ModelInvoiceConditionInput
  $input: CreateInvoiceInput!
) {
  createInvoice(condition: $condition, input: $input) {
    amount
    companyId
    createdAt
    date
    description
    id
    invoiceNumber
    lineItems
    owner
    pdfUrl
    status
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInvoiceMutationVariables,
  APITypes.CreateInvoiceMutation
>;
export const createLaborCategory = /* GraphQL */ `mutation CreateLaborCategory(
  $condition: ModelLaborCategoryConditionInput
  $input: CreateLaborCategoryInput!
) {
  createLaborCategory(condition: $condition, input: $input) {
    companyId
    createdAt
    id
    isActive
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLaborCategoryMutationVariables,
  APITypes.CreateLaborCategoryMutation
>;
export const createLaborRate = /* GraphQL */ `mutation CreateLaborRate(
  $condition: ModelLaborRateConditionInput
  $input: CreateLaborRateInput!
) {
  createLaborRate(condition: $condition, input: $input) {
    categoryId
    createdAt
    effectiveDate
    id
    overtimeRate
    owner
    standardRate
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLaborRateMutationVariables,
  APITypes.CreateLaborRateMutation
>;
export const createLibraryPlanTemplate = /* GraphQL */ `mutation CreateLibraryPlanTemplate(
  $condition: ModelLibraryPlanTemplateConditionInput
  $input: CreateLibraryPlanTemplateInput!
) {
  createLibraryPlanTemplate(condition: $condition, input: $input) {
    categories
    categoryCount
    createdAt
    createdByAdminId
    createdByAdminName
    cycleDuration
    description
    governingStandard
    id
    minimumTimeRequired
    name
    owner
    sharedWithCompanyIds
    status
    topicCount
    updatedAt
    workingDays
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLibraryPlanTemplateMutationVariables,
  APITypes.CreateLibraryPlanTemplateMutation
>;
export const createLibraryTopicTemplate = /* GraphQL */ `mutation CreateLibraryTopicTemplate(
  $condition: ModelLibraryTopicTemplateConditionInput
  $input: CreateLibraryTopicTemplateInput!
) {
  createLibraryTopicTemplate(condition: $condition, input: $input) {
    contentFilePath
    contentUrl
    createdAt
    createdByAdminId
    description
    id
    owner
    style
    timeValue
    topicId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLibraryTopicTemplateMutationVariables,
  APITypes.CreateLibraryTopicTemplateMutation
>;
export const createLocation = /* GraphQL */ `mutation CreateLocation(
  $condition: ModelLocationConditionInput
  $input: CreateLocationInput!
) {
  createLocation(condition: $condition, input: $input) {
    companyId
    createdAt
    description
    id
    name
    owner
    regionalDivisionId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLocationMutationVariables,
  APITypes.CreateLocationMutation
>;
export const createModuleSubscription = /* GraphQL */ `mutation CreateModuleSubscription(
  $condition: ModelModuleSubscriptionConditionInput
  $input: CreateModuleSubscriptionInput!
) {
  createModuleSubscription(condition: $condition, input: $input) {
    activatedAt
    cancelRequestedAt
    companyId
    createdAt
    effectiveEndDate
    id
    moduleKey
    monthlyRate
    owner
    pricingModel
    status
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateModuleSubscriptionMutationVariables,
  APITypes.CreateModuleSubscriptionMutation
>;
export const createPMConfiguration = /* GraphQL */ `mutation CreatePMConfiguration(
  $condition: ModelPMConfigurationConditionInput
  $input: CreatePMConfigurationInput!
) {
  createPMConfiguration(condition: $condition, input: $input) {
    companyId
    createdAt
    dueSoonPercentage
    id
    laborCategoryId
    owner
    unitId
    unitOfMeasure
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePMConfigurationMutationVariables,
  APITypes.CreatePMConfigurationMutation
>;
export const createPMModuleContent = /* GraphQL */ `mutation CreatePMModuleContent(
  $condition: ModelPMModuleContentConditionInput
  $input: CreatePMModuleContentInput!
) {
  createPMModuleContent(condition: $condition, input: $input) {
    createdAt
    id
    owner
    pmServiceFormId
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePMModuleContentMutationVariables,
  APITypes.CreatePMModuleContentMutation
>;
export const createPMNotificationSetting = /* GraphQL */ `mutation CreatePMNotificationSetting(
  $condition: ModelPMNotificationSettingConditionInput
  $input: CreatePMNotificationSettingInput!
) {
  createPMNotificationSetting(condition: $condition, input: $input) {
    createdAt
    emailThresholdUM
    id
    lastNotificationSent
    notificationFrequency
    owner
    pmConfigurationId
    recipients
    serviceLevelId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePMNotificationSettingMutationVariables,
  APITypes.CreatePMNotificationSettingMutation
>;
export const createPMPartsAndProcedure = /* GraphQL */ `mutation CreatePMPartsAndProcedure(
  $condition: ModelPMPartsAndProcedureConditionInput
  $input: CreatePMPartsAndProcedureInput!
) {
  createPMPartsAndProcedure(condition: $condition, input: $input) {
    category
    companyId
    createdAt
    createdByUserId
    createdByUserName
    id
    itemName
    itemType
    manufacturer
    owner
    partNumber
    pmConfigurationId
    pmConfigurationIds
    price
    quantity
    sortOrder
    unitOfMeasure
    updatedAt
    vendorId
    vendorName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePMPartsAndProcedureMutationVariables,
  APITypes.CreatePMPartsAndProcedureMutation
>;
export const createPMReport = /* GraphQL */ `mutation CreatePMReport(
  $condition: ModelPMReportConditionInput
  $input: CreatePMReportInput!
) {
  createPMReport(condition: $condition, input: $input) {
    actualUM
    companyId
    createdAt
    id
    issueDescription
    issueTicketCreated
    issueTicketId
    laborHoursOT
    laborHoursST
    laborRateOT
    laborRateST
    laborRateScheduleId
    laborRateScheduleName
    owner
    photos
    pmConfigurationId
    reportData
    serviceDate
    serviceLevelId
    serviceLevelName
    signature
    status
    technicianId
    technicianName
    totalLaborCost
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePMReportMutationVariables,
  APITypes.CreatePMReportMutation
>;
export const createPMServiceLevel = /* GraphQL */ `mutation CreatePMServiceLevel(
  $condition: ModelPMServiceLevelConditionInput
  $input: CreatePMServiceLevelInput!
) {
  createPMServiceLevel(condition: $condition, input: $input) {
    createdAt
    description
    id
    intervalValue
    lastServiceDate
    lastServiceUM
    levelIdentifier
    owner
    pmConfigurationId
    pmServiceFormId
    serviceLevelAssignments
    targetUM
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePMServiceLevelMutationVariables,
  APITypes.CreatePMServiceLevelMutation
>;
export const createRegionalDivision = /* GraphQL */ `mutation CreateRegionalDivision(
  $condition: ModelRegionalDivisionConditionInput
  $input: CreateRegionalDivisionInput!
) {
  createRegionalDivision(condition: $condition, input: $input) {
    companyId
    createdAt
    description
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRegionalDivisionMutationVariables,
  APITypes.CreateRegionalDivisionMutation
>;
export const createReport = /* GraphQL */ `mutation CreateReport(
  $condition: ModelReportConditionInput
  $input: CreateReportInput!
) {
  createReport(condition: $condition, input: $input) {
    alwaysTriggerEmail
    companyId
    createdAt
    dailyServiceLogReport
    equipmentId
    equipmentLocationId
    equipmentName
    id
    inspectionCompleted
    inspectionStarted
    name
    signature
    unitId
    unitName
    updatedAt
    userData
    userId
    userLocation
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReportMutationVariables,
  APITypes.CreateReportMutation
>;
export const createReportAnswer = /* GraphQL */ `mutation CreateReportAnswer(
  $condition: ModelReportAnswerConditionInput
  $input: CreateReportAnswerInput!
) {
  createReportAnswer(condition: $condition, input: $input) {
    companyId
    createdAt
    id
    notes
    parentReportId
    photos
    promptDescription
    promptKey
    promptLabel
    promptTitle
    promptType
    reportType
    sortOrder
    unitId
    updatedAt
    value
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReportAnswerMutationVariables,
  APITypes.CreateReportAnswerMutation
>;
export const createResourceLibrary = /* GraphQL */ `mutation CreateResourceLibrary(
  $condition: ModelResourceLibraryConditionInput
  $input: CreateResourceLibraryInput!
) {
  createResourceLibrary(condition: $condition, input: $input) {
    companyOwnerId
    createdAt
    id
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateResourceLibraryMutationVariables,
  APITypes.CreateResourceLibraryMutation
>;
export const createSavedReportConfiguration = /* GraphQL */ `mutation CreateSavedReportConfiguration(
  $condition: ModelSavedReportConfigurationConditionInput
  $input: CreateSavedReportConfigurationInput!
) {
  createSavedReportConfiguration(condition: $condition, input: $input) {
    companyId
    compareDateRangeEnd
    compareDateRangeStart
    createdAt
    dateRangeEnd
    dateRangeStart
    dateRangeType
    filtersJson
    groupByField
    id
    lastRunAt
    metricCategory
    metricKey
    reportName
    updatedAt
    userId
    visualizationType
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSavedReportConfigurationMutationVariables,
  APITypes.CreateSavedReportConfigurationMutation
>;
export const createSensitiveUserInfo = /* GraphQL */ `mutation CreateSensitiveUserInfo(
  $condition: ModelSensitiveUserInfoConditionInput
  $input: CreateSensitiveUserInfoInput!
) {
  createSensitiveUserInfo(condition: $condition, input: $input) {
    cognitoId
    companyId
    createdAt
    dateOfBirth
    driversLicenseClass
    driversLicenseExpirationDate
    driversLicenseNumber
    driversLicenseState
    emergencyContactName
    emergencyContactPhoneNumber
    emergencyContactRelationship
    id
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSensitiveUserInfoMutationVariables,
  APITypes.CreateSensitiveUserInfoMutation
>;
export const createShiftReport = /* GraphQL */ `mutation CreateShiftReport(
  $condition: ModelShiftReportConditionInput
  $input: CreateShiftReportInput!
) {
  createShiftReport(condition: $condition, input: $input) {
    alwaysTriggerEmail
    companyId
    createdAt
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    locationId
    locationName
    okCount
    photos
    responseData
    shiftType
    signature
    totalItems
    updatedAt
    userId
    userName
    warnCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateShiftReportMutationVariables,
  APITypes.CreateShiftReportMutation
>;
export const createSingleUnit = /* GraphQL */ `mutation CreateSingleUnit(
  $condition: ModelSingleUnitConditionInput
  $input: CreateSingleUnitInput!
) {
  createSingleUnit(condition: $condition, input: $input) {
    annualProjectedUsage
    aquisitionCost
    aquisitionDate
    assignedTo
    axleConfiguration
    categoryId
    costTrackingModuleEnrollment
    createdAt
    currentMachineHours
    currentUMCounterValue
    dailyServiceLogFormId
    description
    dispositionDate
    dispositionReason
    downReason
    engineManufacturer
    engineModelNumber
    equipmentStatus
    extraUnitInfo
    id
    image
    inputByPerson
    inputDate
    lastDailyServiceDate
    lastInspectionDate
    lastServiceHours
    licenseNumber
    locationId
    machineHoursAtAquisition
    machineUMCounterAtAquisition
    manufactureDate
    manufacturerName
    modelNumber
    name
    pmModuleEnrollment
    putInServiceDate
    removedFromServiceDate
    removedFromServiceReason
    replacedUMCounterHistory
    replacedUMCounterStatus
    replacedUMCounterValue
    serialNumber
    tiresModuleEnrollment
    unitOfMeasure
    updatedAt
    utilizationAdjustmentDays
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSingleUnitMutationVariables,
  APITypes.CreateSingleUnitMutation
>;
export const createSkillAssignment = /* GraphQL */ `mutation CreateSkillAssignment(
  $condition: ModelSkillAssignmentConditionInput
  $input: CreateSkillAssignmentInput!
) {
  createSkillAssignment(condition: $condition, input: $input) {
    companyId
    createdAt
    evaluatedBy
    evaluatedByName
    evaluationDate
    id
    owner
    skillLevel
    subCategoryId
    taskId
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSkillAssignmentMutationVariables,
  APITypes.CreateSkillAssignmentMutation
>;
export const createSkillCategory = /* GraphQL */ `mutation CreateSkillCategory(
  $condition: ModelSkillCategoryConditionInput
  $input: CreateSkillCategoryInput!
) {
  createSkillCategory(condition: $condition, input: $input) {
    allowMachineNumber
    classificationId
    companyId
    createdAt
    equipmentCategoryId
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSkillCategoryMutationVariables,
  APITypes.CreateSkillCategoryMutation
>;
export const createSkillLevel = /* GraphQL */ `mutation CreateSkillLevel(
  $condition: ModelSkillLevelConditionInput
  $input: CreateSkillLevelInput!
) {
  createSkillLevel(condition: $condition, input: $input) {
    color
    companyId
    createdAt
    description
    id
    name
    owner
    sortOrder
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSkillLevelMutationVariables,
  APITypes.CreateSkillLevelMutation
>;
export const createSkillTask = /* GraphQL */ `mutation CreateSkillTask(
  $condition: ModelSkillTaskConditionInput
  $input: CreateSkillTaskInput!
) {
  createSkillTask(condition: $condition, input: $input) {
    categoryId
    companyId
    createdAt
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSkillTaskMutationVariables,
  APITypes.CreateSkillTaskMutation
>;
export const createSubCategory = /* GraphQL */ `mutation CreateSubCategory(
  $condition: ModelSubCategoryConditionInput
  $input: CreateSubCategoryInput!
) {
  createSubCategory(condition: $condition, input: $input) {
    categoryId
    companyId
    createdAt
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSubCategoryMutationVariables,
  APITypes.CreateSubCategoryMutation
>;
export const createTire = /* GraphQL */ `mutation CreateTire(
  $condition: ModelTireConditionInput
  $input: CreateTireInput!
) {
  createTire(condition: $condition, input: $input) {
    assignedAxle
    assignedPosition
    companyId
    createdAt
    currentTirePressure
    currentTreadDepth
    dateInstalled
    dateUninstalled
    failureReason
    id
    inflationMedium
    loadRating
    loadRatingUnit
    minimumTreadDepth
    name
    owner
    recommendedTirePressure
    removedFromService
    removedFromServiceDate
    tireCategory
    tireManufacturer
    tireModel
    tireSize
    tireStatus
    treadDepthAtInstall
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTireMutationVariables,
  APITypes.CreateTireMutation
>;
export const createTireReport = /* GraphQL */ `mutation CreateTireReport(
  $condition: ModelTireReportConditionInput
  $input: CreateTireReportInput!
) {
  createTireReport(condition: $condition, input: $input) {
    alwaysTriggerEmail
    companyId
    createdAt
    equipmentCategoryId
    equipmentCategoryName
    equipmentLocationId
    id
    inspectionCompleted
    inspectionStarted
    name
    signature
    tireId
    unitId
    unitName
    updatedAt
    userData
    userId
    userLocation
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTireReportMutationVariables,
  APITypes.CreateTireReportMutation
>;
export const createTrainingAffidavit = /* GraphQL */ `mutation CreateTrainingAffidavit(
  $condition: ModelTrainingAffidavitConditionInput
  $input: CreateTrainingAffidavitInput!
) {
  createTrainingAffidavit(condition: $condition, input: $input) {
    adminId
    affidavitDate
    companyId
    createdAt
    id
    legalText
    nextDueDate
    owner
    planId
    signaturePath
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTrainingAffidavitMutationVariables,
  APITypes.CreateTrainingAffidavitMutation
>;
export const createTrainingCompletion = /* GraphQL */ `mutation CreateTrainingCompletion(
  $condition: ModelTrainingCompletionConditionInput
  $input: CreateTrainingCompletionInput!
) {
  createTrainingCompletion(condition: $condition, input: $input) {
    categoryId
    companyId
    completionDate
    createdAt
    id
    launched
    markedAsViewed
    owner
    planId
    scheduleDate
    signaturePath
    timeValueMinutes
    topicId
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTrainingCompletionMutationVariables,
  APITypes.CreateTrainingCompletionMutation
>;
export const createTrainingEnrollment = /* GraphQL */ `mutation CreateTrainingEnrollment(
  $condition: ModelTrainingEnrollmentConditionInput
  $input: CreateTrainingEnrollmentInput!
) {
  createTrainingEnrollment(condition: $condition, input: $input) {
    companyId
    createdAt
    enrolledDate
    id
    lastCompletionDate
    nextDueDate
    owner
    planId
    status
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTrainingEnrollmentMutationVariables,
  APITypes.CreateTrainingEnrollmentMutation
>;
export const createTrainingPlan = /* GraphQL */ `mutation CreateTrainingPlan(
  $condition: ModelTrainingPlanConditionInput
  $input: CreateTrainingPlanInput!
) {
  createTrainingPlan(condition: $condition, input: $input) {
    categories
    companyId
    createdAt
    cycleDuration
    governingStandard
    holidays
    id
    minimumTimeRequired
    name
    owner
    startDate
    status
    updatedAt
    workingDays
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTrainingPlanMutationVariables,
  APITypes.CreateTrainingPlanMutation
>;
export const createTrainingQuizResponse = /* GraphQL */ `mutation CreateTrainingQuizResponse(
  $condition: ModelTrainingQuizResponseConditionInput
  $input: CreateTrainingQuizResponseInput!
) {
  createTrainingQuizResponse(condition: $condition, input: $input) {
    attemptNumber
    categoryId
    companyId
    completedAt
    createdAt
    cycleStartDate
    formId
    id
    owner
    passed
    planId
    responseData
    score
    signaturePath
    totalQuestions
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTrainingQuizResponseMutationVariables,
  APITypes.CreateTrainingQuizResponseMutation
>;
export const createTrainingSchedule = /* GraphQL */ `mutation CreateTrainingSchedule(
  $condition: ModelTrainingScheduleConditionInput
  $input: CreateTrainingScheduleInput!
) {
  createTrainingSchedule(condition: $condition, input: $input) {
    assignedUserId
    categoryId
    companyId
    createdAt
    dayNumber
    id
    locked
    owner
    planId
    scheduledDate
    topicId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTrainingScheduleMutationVariables,
  APITypes.CreateTrainingScheduleMutation
>;
export const createTrainingTopic = /* GraphQL */ `mutation CreateTrainingTopic(
  $condition: ModelTrainingTopicConditionInput
  $input: CreateTrainingTopicInput!
) {
  createTrainingTopic(condition: $condition, input: $input) {
    categoryIds
    companyId
    companyResourceId
    contentFilePath
    contentUrl
    createdAt
    description
    id
    owner
    planIds
    style
    timeValue
    topicId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTrainingTopicMutationVariables,
  APITypes.CreateTrainingTopicMutation
>;
export const createUnitExpenseBudget = /* GraphQL */ `mutation CreateUnitExpenseBudget(
  $condition: ModelUnitExpenseBudgetConditionInput
  $input: CreateUnitExpenseBudgetInput!
) {
  createUnitExpenseBudget(condition: $condition, input: $input) {
    companyId
    createdAt
    expenseCategoryId
    id
    owner
    startingBalance
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUnitExpenseBudgetMutationVariables,
  APITypes.CreateUnitExpenseBudgetMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser(
  $condition: ModelUserConditionInput
  $input: CreateUserInput!
) {
  createUser(condition: $condition, input: $input) {
    archived
    cognitoId
    companyId
    contactPhoneNumber
    contactPhoneType
    createdAt
    currentJobClassification
    dateOfHire
    discrepancyNotification
    discrepancyNotificationTypes
    domain
    driversLicenseStatus
    email
    globalLocationPermission
    id
    inputByPerson
    inputDate
    locationAssignment
    name
    notesAboutUser
    onHighwayEligibility
    owner
    permissions
    personalIdentification
    pmNotification
    pmNotificationTypes
    position
    regionalAssignment
    role
    safetyLessons
    skillTrackingModuleEnrollment
    trainingModuleEnrollment
    trainingNotification
    trainingNotificationTypes
    updatedAt
    userPhoto
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const createUserFile = /* GraphQL */ `mutation CreateUserFile(
  $condition: ModelUserFileConditionInput
  $input: CreateUserFileInput!
) {
  createUserFile(condition: $condition, input: $input) {
    companyId
    createdAt
    fileName
    fileSize
    id
    owner
    s3Path
    updatedAt
    uploadedAt
    uploadedBy
    uploadedByName
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserFileMutationVariables,
  APITypes.CreateUserFileMutation
>;
export const createUserReportFavorite = /* GraphQL */ `mutation CreateUserReportFavorite(
  $condition: ModelUserReportFavoriteConditionInput
  $input: CreateUserReportFavoriteInput!
) {
  createUserReportFavorite(condition: $condition, input: $input) {
    companyId
    createdAt
    id
    reportTypeKey
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserReportFavoriteMutationVariables,
  APITypes.CreateUserReportFavoriteMutation
>;
export const createUserSkillReport = /* GraphQL */ `mutation CreateUserSkillReport(
  $condition: ModelUserSkillReportConditionInput
  $input: CreateUserSkillReportInput!
) {
  createUserSkillReport(condition: $condition, input: $input) {
    assessorId
    assessorName
    companyId
    createdAt
    expirationDate
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    okCount
    passFailStatus
    photos
    qualificationLevel
    responseData
    signature
    skillCategory
    skillName
    totalItems
    updatedAt
    userId
    userName
    warnCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserSkillReportMutationVariables,
  APITypes.CreateUserSkillReportMutation
>;
export const createVendorList = /* GraphQL */ `mutation CreateVendorList(
  $condition: ModelVendorListConditionInput
  $input: CreateVendorListInput!
) {
  createVendorList(condition: $condition, input: $input) {
    address
    companyId
    createdAt
    faxNumber
    id
    name
    owner
    phoneNumber
    repName
    repPhoneNumber
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateVendorListMutationVariables,
  APITypes.CreateVendorListMutation
>;
export const createVideo = /* GraphQL */ `mutation CreateVideo(
  $condition: ModelVideoConditionInput
  $input: CreateVideoInput!
) {
  createVideo(condition: $condition, input: $input) {
    assignedSafetyLesson
    contentPath
    createdAt
    folderName
    id
    owner
    resourceLibraryID
    safetyLesson
    sharedWithCompanyIds
    title
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateVideoMutationVariables,
  APITypes.CreateVideoMutation
>;
export const deleteArchivedDiscrepancy = /* GraphQL */ `mutation DeleteArchivedDiscrepancy(
  $condition: ModelArchivedDiscrepancyConditionInput
  $input: DeleteArchivedDiscrepancyInput!
) {
  deleteArchivedDiscrepancy(condition: $condition, input: $input) {
    archivedDate
    companyId
    createdAt
    downReason
    equipmentId
    equipmentName
    id
    initialStatus
    log
    owner
    promptDescription
    promptLabel
    promptTitle
    questionIndex
    reportId
    status
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteArchivedDiscrepancyMutationVariables,
  APITypes.DeleteArchivedDiscrepancyMutation
>;
export const deleteAuditLog = /* GraphQL */ `mutation DeleteAuditLog(
  $condition: ModelAuditLogConditionInput
  $input: DeleteAuditLogInput!
) {
  deleteAuditLog(condition: $condition, input: $input) {
    action
    companyId
    createdAt
    details
    id
    resourceId
    resourceName
    resourceType
    ttl
    updatedAt
    userId
    userName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAuditLogMutationVariables,
  APITypes.DeleteAuditLogMutation
>;
export const deleteAxleBlueprint = /* GraphQL */ `mutation DeleteAxleBlueprint(
  $condition: ModelAxleBlueprintConditionInput
  $input: DeleteAxleBlueprintInput!
) {
  deleteAxleBlueprint(condition: $condition, input: $input) {
    axles
    centerlineLength
    companyId
    createdAt
    description
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAxleBlueprintMutationVariables,
  APITypes.DeleteAxleBlueprintMutation
>;
export const deleteBillingRate = /* GraphQL */ `mutation DeleteBillingRate(
  $condition: ModelBillingRateConditionInput
  $input: DeleteBillingRateInput!
) {
  deleteBillingRate(condition: $condition, input: $input) {
    companyId
    createdAt
    id
    owner
    ratePerCostTracking
    ratePerEquipment
    ratePerPM
    ratePerSafetyEnrollment
    ratePerSkillQualification
    ratePerTireMaint
    ratePerUser
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBillingRateMutationVariables,
  APITypes.DeleteBillingRateMutation
>;
export const deleteBusinessAdmin = /* GraphQL */ `mutation DeleteBusinessAdmin(
  $condition: ModelBusinessAdminConditionInput
  $input: DeleteBusinessAdminInput!
) {
  deleteBusinessAdmin(condition: $condition, input: $input) {
    cognitoId
    createdAt
    domain
    email
    id
    name
    owner
    permissions
    role
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBusinessAdminMutationVariables,
  APITypes.DeleteBusinessAdminMutation
>;
export const deleteChangeLogEntry = /* GraphQL */ `mutation DeleteChangeLogEntry(
  $condition: ModelChangeLogEntryConditionInput
  $input: DeleteChangeLogEntryInput!
) {
  deleteChangeLogEntry(condition: $condition, input: $input) {
    changedBy
    changedByName
    companyId
    createdAt
    description
    fieldName
    id
    newValue
    oldValue
    owner
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteChangeLogEntryMutationVariables,
  APITypes.DeleteChangeLogEntryMutation
>;
export const deleteClassification = /* GraphQL */ `mutation DeleteClassification(
  $condition: ModelClassificationConditionInput
  $input: DeleteClassificationInput!
) {
  deleteClassification(condition: $condition, input: $input) {
    companyId
    createdAt
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteClassificationMutationVariables,
  APITypes.DeleteClassificationMutation
>;
export const deleteCompany = /* GraphQL */ `mutation DeleteCompany(
  $condition: ModelCompanyConditionInput
  $input: DeleteCompanyInput!
) {
  deleteCompany(condition: $condition, input: $input) {
    accountNumber
    accountOrigin
    accountStatus
    addOnGracePeriodEndDate
    archived
    assignedRep
    billingAnchorDay
    billingContactAddress
    billingContactEmail
    billingContactName
    billingContactPhone
    billingCycle
    businessType
    cancelEffectiveDate
    cancelReason
    cancelReasonNote
    cancelRequestedAt
    companyOwnerId
    coreMonthlyRate
    costTrackingModuleEnrollment
    createdAt
    dataRetentionEndDate
    description
    gracePeriodEndDate
    id
    industryNAICS
    industrySIC
    initialContactDate
    initialStarterPackageEnrollment
    logo
    maxNumberEquipment
    maxNumberUsers
    name
    nextBillingDate
    notes
    numberOfUsers
    paidStartDate
    paymentFailedAt
    paymentMethod
    pmModuleEnrollment
    primaryContactEmail
    primaryContactName
    primaryContactPhone
    primaryContactPosition
    primaryLocation
    referredBy
    retryAttempts
    safetyComplianceStandard
    secondaryContactEmail
    secondaryContactName
    secondaryContactPhone
    secondaryContactPosition
    skillTrackingModuleEnrollment
    starterPackage
    status
    subscriptionExpiration
    subscriptionType
    tiresModuleEnrollment
    trainingModuleEnrollment
    trialEndDate
    trialStartDate
    type
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCompanyMutationVariables,
  APITypes.DeleteCompanyMutation
>;
export const deleteCompanyNote = /* GraphQL */ `mutation DeleteCompanyNote(
  $condition: ModelCompanyNoteConditionInput
  $input: DeleteCompanyNoteInput!
) {
  deleteCompanyNote(condition: $condition, input: $input) {
    authorName
    companyId
    content
    createdAt
    id
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCompanyNoteMutationVariables,
  APITypes.DeleteCompanyNoteMutation
>;
export const deleteCompanyOwner = /* GraphQL */ `mutation DeleteCompanyOwner(
  $condition: ModelCompanyOwnerConditionInput
  $input: DeleteCompanyOwnerInput!
) {
  deleteCompanyOwner(condition: $condition, input: $input) {
    cognitoId
    companyId
    contactPhoneNumber
    createdAt
    discrepancyNotification
    discrepancyNotificationTypes
    domain
    email
    id
    name
    owner
    permissions
    pmNotification
    pmNotificationTypes
    role
    siteAdmin
    subscriptionType
    trainingNotification
    trainingNotificationTypes
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCompanyOwnerMutationVariables,
  APITypes.DeleteCompanyOwnerMutation
>;
export const deleteCompanyResource = /* GraphQL */ `mutation DeleteCompanyResource(
  $condition: ModelCompanyResourceConditionInput
  $input: DeleteCompanyResourceInput!
) {
  deleteCompanyResource(condition: $condition, input: $input) {
    category
    companyId
    contentFilePath
    contentUrl
    createdAt
    description
    fileType
    folderName
    id
    owner
    title
    trainingTopicId
    updatedAt
    uploadedByUserId
    uploadedByUserName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCompanyResourceMutationVariables,
  APITypes.DeleteCompanyResourceMutation
>;
export const deleteDOTInspectionReport = /* GraphQL */ `mutation DeleteDOTInspectionReport(
  $condition: ModelDOTInspectionReportConditionInput
  $input: DeleteDOTInspectionReportInput!
) {
  deleteDOTInspectionReport(condition: $condition, input: $input) {
    companyId
    complianceStatus
    createdAt
    dotInspectionType
    equipmentCategoryId
    equipmentCategoryName
    expirationDate
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    inspectorCertificationId
    locationId
    okCount
    photos
    regulatoryStandard
    responseData
    signature
    totalItems
    unitId
    unitName
    updatedAt
    userId
    userName
    vehicleLicensePlate
    vehicleVIN
    warnCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDOTInspectionReportMutationVariables,
  APITypes.DeleteDOTInspectionReportMutation
>;
export const deleteDailyServiceReport = /* GraphQL */ `mutation DeleteDailyServiceReport(
  $condition: ModelDailyServiceReportConditionInput
  $input: DeleteDailyServiceReportInput!
) {
  deleteDailyServiceReport(condition: $condition, input: $input) {
    companyId
    createdAt
    dailyServiceLogFormId
    equipmentCategoryId
    equipmentCategoryName
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    locationId
    machineHoursAtService
    okCount
    photos
    responseData
    signature
    totalItems
    umCounterAtService
    unitId
    unitName
    updatedAt
    userId
    userName
    warnCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDailyServiceReportMutationVariables,
  APITypes.DeleteDailyServiceReportMutation
>;
export const deleteDiscrepancy = /* GraphQL */ `mutation DeleteDiscrepancy(
  $condition: ModelDiscrepancyConditionInput
  $input: DeleteDiscrepancyInput!
) {
  deleteDiscrepancy(condition: $condition, input: $input) {
    companyId
    createdAt
    downReason
    equipmentId
    equipmentName
    id
    initialStatus
    log
    owner
    promptDescription
    promptLabel
    promptTitle
    questionIndex
    reportId
    status
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDiscrepancyMutationVariables,
  APITypes.DeleteDiscrepancyMutation
>;
export const deleteDocument = /* GraphQL */ `mutation DeleteDocument(
  $condition: ModelDocumentConditionInput
  $input: DeleteDocumentInput!
) {
  deleteDocument(condition: $condition, input: $input) {
    assignedSafetyLesson
    contentPath
    createdAt
    folderName
    id
    owner
    resourceLibraryID
    safetyLesson
    sharedWithCompanyIds
    title
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDocumentMutationVariables,
  APITypes.DeleteDocumentMutation
>;
export const deleteEquipment = /* GraphQL */ `mutation DeleteEquipment(
  $condition: ModelEquipmentConditionInput
  $input: DeleteEquipmentInput!
) {
  deleteEquipment(condition: $condition, input: $input) {
    companyId
    createdAt
    formId
    id
    image
    name
    units
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEquipmentMutationVariables,
  APITypes.DeleteEquipmentMutation
>;
export const deleteEquipmentCategory = /* GraphQL */ `mutation DeleteEquipmentCategory(
  $condition: ModelEquipmentCategoryConditionInput
  $input: DeleteEquipmentCategoryInput!
) {
  deleteEquipmentCategory(condition: $condition, input: $input) {
    companyId
    createdAt
    formId
    id
    image
    name
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEquipmentCategoryMutationVariables,
  APITypes.DeleteEquipmentCategoryMutation
>;
export const deleteErrors = /* GraphQL */ `mutation DeleteErrors(
  $condition: ModelErrorsConditionInput
  $input: DeleteErrorsInput!
) {
  deleteErrors(condition: $condition, input: $input) {
    createdAt
    errors
    id
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteErrorsMutationVariables,
  APITypes.DeleteErrorsMutation
>;
export const deleteExpenseCategory = /* GraphQL */ `mutation DeleteExpenseCategory(
  $condition: ModelExpenseCategoryConditionInput
  $input: DeleteExpenseCategoryInput!
) {
  deleteExpenseCategory(condition: $condition, input: $input) {
    companyId
    createdAt
    id
    name
    owner
    startingBalance
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteExpenseCategoryMutationVariables,
  APITypes.DeleteExpenseCategoryMutation
>;
export const deleteExpenseRecord = /* GraphQL */ `mutation DeleteExpenseRecord(
  $condition: ModelExpenseRecordConditionInput
  $input: DeleteExpenseRecordInput!
) {
  deleteExpenseRecord(condition: $condition, input: $input) {
    attachments
    companyId
    createdAt
    dateOfInput
    dateOfService
    equipmentCategoryId
    expenseCategories
    id
    invoiceNumber
    laborHoursOT
    laborHoursST
    laborRateOT
    laborRateST
    laborRateScheduleId
    laborRateScheduleName
    owner
    pmExpense
    pmServiceLevelId
    pmServiceLevelName
    totalExpense
    totalLaborCost
    unitId
    updatedAt
    vendorId
    vendorName
    workDescription
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteExpenseRecordMutationVariables,
  APITypes.DeleteExpenseRecordMutation
>;
export const deleteForm = /* GraphQL */ `mutation DeleteForm(
  $condition: ModelFormConditionInput
  $input: DeleteFormInput!
) {
  deleteForm(condition: $condition, input: $input) {
    alwaysTriggerEmail
    companyId
    createdAt
    dailyServiceLogForm
    equipmentType
    formData
    formType
    id
    inspectionForm
    name
    noMachineHours
    noUMCounter
    owner
    pmServiceScheduleForm
    status
    umCounterLabel
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFormMutationVariables,
  APITypes.DeleteFormMutation
>;
export const deleteFormTemplate = /* GraphQL */ `mutation DeleteFormTemplate(
  $condition: ModelFormTemplateConditionInput
  $input: DeleteFormTemplateInput!
) {
  deleteFormTemplate(condition: $condition, input: $input) {
    createdAt
    createdByCompanyOwnerId
    dailyServiceLogForm
    formTemplateGroupID
    id
    inspectionForm
    originalCompanyId
    owner
    pmServiceScheduleForm
    templateData
    templateName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFormTemplateMutationVariables,
  APITypes.DeleteFormTemplateMutation
>;
export const deleteFormTemplateGroup = /* GraphQL */ `mutation DeleteFormTemplateGroup(
  $condition: ModelFormTemplateGroupConditionInput
  $input: DeleteFormTemplateGroupInput!
) {
  deleteFormTemplateGroup(condition: $condition, input: $input) {
    createdAt
    description
    id
    name
    owner
    resourceLibraryID
    sharedWithCompanyIds
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFormTemplateGroupMutationVariables,
  APITypes.DeleteFormTemplateGroupMutation
>;
export const deleteHelpSupportDoc = /* GraphQL */ `mutation DeleteHelpSupportDoc(
  $condition: ModelHelpSupportDocConditionInput
  $input: DeleteHelpSupportDocInput!
) {
  deleteHelpSupportDoc(condition: $condition, input: $input) {
    contentFilePath
    contentUrl
    createdAt
    createdByAdminId
    description
    docType
    id
    owner
    sharedWithCompanyIds
    status
    title
    updatedAt
    visibility
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteHelpSupportDocMutationVariables,
  APITypes.DeleteHelpSupportDocMutation
>;
export const deleteInspectionReport = /* GraphQL */ `mutation DeleteInspectionReport(
  $condition: ModelInspectionReportConditionInput
  $input: DeleteInspectionReportInput!
) {
  deleteInspectionReport(condition: $condition, input: $input) {
    alwaysTriggerEmail
    companyId
    createdAt
    equipmentCategoryId
    equipmentCategoryName
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    locationId
    machineHoursAtInspection
    okCount
    photos
    responseData
    signature
    totalItems
    umCounterAtInspection
    unitId
    unitName
    updatedAt
    userId
    userName
    warnCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteInspectionReportMutationVariables,
  APITypes.DeleteInspectionReportMutation
>;
export const deleteInvoice = /* GraphQL */ `mutation DeleteInvoice(
  $condition: ModelInvoiceConditionInput
  $input: DeleteInvoiceInput!
) {
  deleteInvoice(condition: $condition, input: $input) {
    amount
    companyId
    createdAt
    date
    description
    id
    invoiceNumber
    lineItems
    owner
    pdfUrl
    status
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteInvoiceMutationVariables,
  APITypes.DeleteInvoiceMutation
>;
export const deleteLaborCategory = /* GraphQL */ `mutation DeleteLaborCategory(
  $condition: ModelLaborCategoryConditionInput
  $input: DeleteLaborCategoryInput!
) {
  deleteLaborCategory(condition: $condition, input: $input) {
    companyId
    createdAt
    id
    isActive
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLaborCategoryMutationVariables,
  APITypes.DeleteLaborCategoryMutation
>;
export const deleteLaborRate = /* GraphQL */ `mutation DeleteLaborRate(
  $condition: ModelLaborRateConditionInput
  $input: DeleteLaborRateInput!
) {
  deleteLaborRate(condition: $condition, input: $input) {
    categoryId
    createdAt
    effectiveDate
    id
    overtimeRate
    owner
    standardRate
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLaborRateMutationVariables,
  APITypes.DeleteLaborRateMutation
>;
export const deleteLibraryPlanTemplate = /* GraphQL */ `mutation DeleteLibraryPlanTemplate(
  $condition: ModelLibraryPlanTemplateConditionInput
  $input: DeleteLibraryPlanTemplateInput!
) {
  deleteLibraryPlanTemplate(condition: $condition, input: $input) {
    categories
    categoryCount
    createdAt
    createdByAdminId
    createdByAdminName
    cycleDuration
    description
    governingStandard
    id
    minimumTimeRequired
    name
    owner
    sharedWithCompanyIds
    status
    topicCount
    updatedAt
    workingDays
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLibraryPlanTemplateMutationVariables,
  APITypes.DeleteLibraryPlanTemplateMutation
>;
export const deleteLibraryTopicTemplate = /* GraphQL */ `mutation DeleteLibraryTopicTemplate(
  $condition: ModelLibraryTopicTemplateConditionInput
  $input: DeleteLibraryTopicTemplateInput!
) {
  deleteLibraryTopicTemplate(condition: $condition, input: $input) {
    contentFilePath
    contentUrl
    createdAt
    createdByAdminId
    description
    id
    owner
    style
    timeValue
    topicId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLibraryTopicTemplateMutationVariables,
  APITypes.DeleteLibraryTopicTemplateMutation
>;
export const deleteLocation = /* GraphQL */ `mutation DeleteLocation(
  $condition: ModelLocationConditionInput
  $input: DeleteLocationInput!
) {
  deleteLocation(condition: $condition, input: $input) {
    companyId
    createdAt
    description
    id
    name
    owner
    regionalDivisionId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLocationMutationVariables,
  APITypes.DeleteLocationMutation
>;
export const deleteModuleSubscription = /* GraphQL */ `mutation DeleteModuleSubscription(
  $condition: ModelModuleSubscriptionConditionInput
  $input: DeleteModuleSubscriptionInput!
) {
  deleteModuleSubscription(condition: $condition, input: $input) {
    activatedAt
    cancelRequestedAt
    companyId
    createdAt
    effectiveEndDate
    id
    moduleKey
    monthlyRate
    owner
    pricingModel
    status
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteModuleSubscriptionMutationVariables,
  APITypes.DeleteModuleSubscriptionMutation
>;
export const deletePMConfiguration = /* GraphQL */ `mutation DeletePMConfiguration(
  $condition: ModelPMConfigurationConditionInput
  $input: DeletePMConfigurationInput!
) {
  deletePMConfiguration(condition: $condition, input: $input) {
    companyId
    createdAt
    dueSoonPercentage
    id
    laborCategoryId
    owner
    unitId
    unitOfMeasure
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePMConfigurationMutationVariables,
  APITypes.DeletePMConfigurationMutation
>;
export const deletePMModuleContent = /* GraphQL */ `mutation DeletePMModuleContent(
  $condition: ModelPMModuleContentConditionInput
  $input: DeletePMModuleContentInput!
) {
  deletePMModuleContent(condition: $condition, input: $input) {
    createdAt
    id
    owner
    pmServiceFormId
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePMModuleContentMutationVariables,
  APITypes.DeletePMModuleContentMutation
>;
export const deletePMNotificationSetting = /* GraphQL */ `mutation DeletePMNotificationSetting(
  $condition: ModelPMNotificationSettingConditionInput
  $input: DeletePMNotificationSettingInput!
) {
  deletePMNotificationSetting(condition: $condition, input: $input) {
    createdAt
    emailThresholdUM
    id
    lastNotificationSent
    notificationFrequency
    owner
    pmConfigurationId
    recipients
    serviceLevelId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePMNotificationSettingMutationVariables,
  APITypes.DeletePMNotificationSettingMutation
>;
export const deletePMPartsAndProcedure = /* GraphQL */ `mutation DeletePMPartsAndProcedure(
  $condition: ModelPMPartsAndProcedureConditionInput
  $input: DeletePMPartsAndProcedureInput!
) {
  deletePMPartsAndProcedure(condition: $condition, input: $input) {
    category
    companyId
    createdAt
    createdByUserId
    createdByUserName
    id
    itemName
    itemType
    manufacturer
    owner
    partNumber
    pmConfigurationId
    pmConfigurationIds
    price
    quantity
    sortOrder
    unitOfMeasure
    updatedAt
    vendorId
    vendorName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePMPartsAndProcedureMutationVariables,
  APITypes.DeletePMPartsAndProcedureMutation
>;
export const deletePMReport = /* GraphQL */ `mutation DeletePMReport(
  $condition: ModelPMReportConditionInput
  $input: DeletePMReportInput!
) {
  deletePMReport(condition: $condition, input: $input) {
    actualUM
    companyId
    createdAt
    id
    issueDescription
    issueTicketCreated
    issueTicketId
    laborHoursOT
    laborHoursST
    laborRateOT
    laborRateST
    laborRateScheduleId
    laborRateScheduleName
    owner
    photos
    pmConfigurationId
    reportData
    serviceDate
    serviceLevelId
    serviceLevelName
    signature
    status
    technicianId
    technicianName
    totalLaborCost
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePMReportMutationVariables,
  APITypes.DeletePMReportMutation
>;
export const deletePMServiceLevel = /* GraphQL */ `mutation DeletePMServiceLevel(
  $condition: ModelPMServiceLevelConditionInput
  $input: DeletePMServiceLevelInput!
) {
  deletePMServiceLevel(condition: $condition, input: $input) {
    createdAt
    description
    id
    intervalValue
    lastServiceDate
    lastServiceUM
    levelIdentifier
    owner
    pmConfigurationId
    pmServiceFormId
    serviceLevelAssignments
    targetUM
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePMServiceLevelMutationVariables,
  APITypes.DeletePMServiceLevelMutation
>;
export const deleteRegionalDivision = /* GraphQL */ `mutation DeleteRegionalDivision(
  $condition: ModelRegionalDivisionConditionInput
  $input: DeleteRegionalDivisionInput!
) {
  deleteRegionalDivision(condition: $condition, input: $input) {
    companyId
    createdAt
    description
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRegionalDivisionMutationVariables,
  APITypes.DeleteRegionalDivisionMutation
>;
export const deleteReport = /* GraphQL */ `mutation DeleteReport(
  $condition: ModelReportConditionInput
  $input: DeleteReportInput!
) {
  deleteReport(condition: $condition, input: $input) {
    alwaysTriggerEmail
    companyId
    createdAt
    dailyServiceLogReport
    equipmentId
    equipmentLocationId
    equipmentName
    id
    inspectionCompleted
    inspectionStarted
    name
    signature
    unitId
    unitName
    updatedAt
    userData
    userId
    userLocation
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteReportMutationVariables,
  APITypes.DeleteReportMutation
>;
export const deleteReportAnswer = /* GraphQL */ `mutation DeleteReportAnswer(
  $condition: ModelReportAnswerConditionInput
  $input: DeleteReportAnswerInput!
) {
  deleteReportAnswer(condition: $condition, input: $input) {
    companyId
    createdAt
    id
    notes
    parentReportId
    photos
    promptDescription
    promptKey
    promptLabel
    promptTitle
    promptType
    reportType
    sortOrder
    unitId
    updatedAt
    value
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteReportAnswerMutationVariables,
  APITypes.DeleteReportAnswerMutation
>;
export const deleteResourceLibrary = /* GraphQL */ `mutation DeleteResourceLibrary(
  $condition: ModelResourceLibraryConditionInput
  $input: DeleteResourceLibraryInput!
) {
  deleteResourceLibrary(condition: $condition, input: $input) {
    companyOwnerId
    createdAt
    id
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteResourceLibraryMutationVariables,
  APITypes.DeleteResourceLibraryMutation
>;
export const deleteSavedReportConfiguration = /* GraphQL */ `mutation DeleteSavedReportConfiguration(
  $condition: ModelSavedReportConfigurationConditionInput
  $input: DeleteSavedReportConfigurationInput!
) {
  deleteSavedReportConfiguration(condition: $condition, input: $input) {
    companyId
    compareDateRangeEnd
    compareDateRangeStart
    createdAt
    dateRangeEnd
    dateRangeStart
    dateRangeType
    filtersJson
    groupByField
    id
    lastRunAt
    metricCategory
    metricKey
    reportName
    updatedAt
    userId
    visualizationType
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSavedReportConfigurationMutationVariables,
  APITypes.DeleteSavedReportConfigurationMutation
>;
export const deleteSensitiveUserInfo = /* GraphQL */ `mutation DeleteSensitiveUserInfo(
  $condition: ModelSensitiveUserInfoConditionInput
  $input: DeleteSensitiveUserInfoInput!
) {
  deleteSensitiveUserInfo(condition: $condition, input: $input) {
    cognitoId
    companyId
    createdAt
    dateOfBirth
    driversLicenseClass
    driversLicenseExpirationDate
    driversLicenseNumber
    driversLicenseState
    emergencyContactName
    emergencyContactPhoneNumber
    emergencyContactRelationship
    id
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSensitiveUserInfoMutationVariables,
  APITypes.DeleteSensitiveUserInfoMutation
>;
export const deleteShiftReport = /* GraphQL */ `mutation DeleteShiftReport(
  $condition: ModelShiftReportConditionInput
  $input: DeleteShiftReportInput!
) {
  deleteShiftReport(condition: $condition, input: $input) {
    alwaysTriggerEmail
    companyId
    createdAt
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    locationId
    locationName
    okCount
    photos
    responseData
    shiftType
    signature
    totalItems
    updatedAt
    userId
    userName
    warnCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteShiftReportMutationVariables,
  APITypes.DeleteShiftReportMutation
>;
export const deleteSingleUnit = /* GraphQL */ `mutation DeleteSingleUnit(
  $condition: ModelSingleUnitConditionInput
  $input: DeleteSingleUnitInput!
) {
  deleteSingleUnit(condition: $condition, input: $input) {
    annualProjectedUsage
    aquisitionCost
    aquisitionDate
    assignedTo
    axleConfiguration
    categoryId
    costTrackingModuleEnrollment
    createdAt
    currentMachineHours
    currentUMCounterValue
    dailyServiceLogFormId
    description
    dispositionDate
    dispositionReason
    downReason
    engineManufacturer
    engineModelNumber
    equipmentStatus
    extraUnitInfo
    id
    image
    inputByPerson
    inputDate
    lastDailyServiceDate
    lastInspectionDate
    lastServiceHours
    licenseNumber
    locationId
    machineHoursAtAquisition
    machineUMCounterAtAquisition
    manufactureDate
    manufacturerName
    modelNumber
    name
    pmModuleEnrollment
    putInServiceDate
    removedFromServiceDate
    removedFromServiceReason
    replacedUMCounterHistory
    replacedUMCounterStatus
    replacedUMCounterValue
    serialNumber
    tiresModuleEnrollment
    unitOfMeasure
    updatedAt
    utilizationAdjustmentDays
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSingleUnitMutationVariables,
  APITypes.DeleteSingleUnitMutation
>;
export const deleteSkillAssignment = /* GraphQL */ `mutation DeleteSkillAssignment(
  $condition: ModelSkillAssignmentConditionInput
  $input: DeleteSkillAssignmentInput!
) {
  deleteSkillAssignment(condition: $condition, input: $input) {
    companyId
    createdAt
    evaluatedBy
    evaluatedByName
    evaluationDate
    id
    owner
    skillLevel
    subCategoryId
    taskId
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSkillAssignmentMutationVariables,
  APITypes.DeleteSkillAssignmentMutation
>;
export const deleteSkillCategory = /* GraphQL */ `mutation DeleteSkillCategory(
  $condition: ModelSkillCategoryConditionInput
  $input: DeleteSkillCategoryInput!
) {
  deleteSkillCategory(condition: $condition, input: $input) {
    allowMachineNumber
    classificationId
    companyId
    createdAt
    equipmentCategoryId
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSkillCategoryMutationVariables,
  APITypes.DeleteSkillCategoryMutation
>;
export const deleteSkillLevel = /* GraphQL */ `mutation DeleteSkillLevel(
  $condition: ModelSkillLevelConditionInput
  $input: DeleteSkillLevelInput!
) {
  deleteSkillLevel(condition: $condition, input: $input) {
    color
    companyId
    createdAt
    description
    id
    name
    owner
    sortOrder
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSkillLevelMutationVariables,
  APITypes.DeleteSkillLevelMutation
>;
export const deleteSkillTask = /* GraphQL */ `mutation DeleteSkillTask(
  $condition: ModelSkillTaskConditionInput
  $input: DeleteSkillTaskInput!
) {
  deleteSkillTask(condition: $condition, input: $input) {
    categoryId
    companyId
    createdAt
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSkillTaskMutationVariables,
  APITypes.DeleteSkillTaskMutation
>;
export const deleteSubCategory = /* GraphQL */ `mutation DeleteSubCategory(
  $condition: ModelSubCategoryConditionInput
  $input: DeleteSubCategoryInput!
) {
  deleteSubCategory(condition: $condition, input: $input) {
    categoryId
    companyId
    createdAt
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSubCategoryMutationVariables,
  APITypes.DeleteSubCategoryMutation
>;
export const deleteTire = /* GraphQL */ `mutation DeleteTire(
  $condition: ModelTireConditionInput
  $input: DeleteTireInput!
) {
  deleteTire(condition: $condition, input: $input) {
    assignedAxle
    assignedPosition
    companyId
    createdAt
    currentTirePressure
    currentTreadDepth
    dateInstalled
    dateUninstalled
    failureReason
    id
    inflationMedium
    loadRating
    loadRatingUnit
    minimumTreadDepth
    name
    owner
    recommendedTirePressure
    removedFromService
    removedFromServiceDate
    tireCategory
    tireManufacturer
    tireModel
    tireSize
    tireStatus
    treadDepthAtInstall
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTireMutationVariables,
  APITypes.DeleteTireMutation
>;
export const deleteTireReport = /* GraphQL */ `mutation DeleteTireReport(
  $condition: ModelTireReportConditionInput
  $input: DeleteTireReportInput!
) {
  deleteTireReport(condition: $condition, input: $input) {
    alwaysTriggerEmail
    companyId
    createdAt
    equipmentCategoryId
    equipmentCategoryName
    equipmentLocationId
    id
    inspectionCompleted
    inspectionStarted
    name
    signature
    tireId
    unitId
    unitName
    updatedAt
    userData
    userId
    userLocation
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTireReportMutationVariables,
  APITypes.DeleteTireReportMutation
>;
export const deleteTrainingAffidavit = /* GraphQL */ `mutation DeleteTrainingAffidavit(
  $condition: ModelTrainingAffidavitConditionInput
  $input: DeleteTrainingAffidavitInput!
) {
  deleteTrainingAffidavit(condition: $condition, input: $input) {
    adminId
    affidavitDate
    companyId
    createdAt
    id
    legalText
    nextDueDate
    owner
    planId
    signaturePath
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTrainingAffidavitMutationVariables,
  APITypes.DeleteTrainingAffidavitMutation
>;
export const deleteTrainingCompletion = /* GraphQL */ `mutation DeleteTrainingCompletion(
  $condition: ModelTrainingCompletionConditionInput
  $input: DeleteTrainingCompletionInput!
) {
  deleteTrainingCompletion(condition: $condition, input: $input) {
    categoryId
    companyId
    completionDate
    createdAt
    id
    launched
    markedAsViewed
    owner
    planId
    scheduleDate
    signaturePath
    timeValueMinutes
    topicId
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTrainingCompletionMutationVariables,
  APITypes.DeleteTrainingCompletionMutation
>;
export const deleteTrainingEnrollment = /* GraphQL */ `mutation DeleteTrainingEnrollment(
  $condition: ModelTrainingEnrollmentConditionInput
  $input: DeleteTrainingEnrollmentInput!
) {
  deleteTrainingEnrollment(condition: $condition, input: $input) {
    companyId
    createdAt
    enrolledDate
    id
    lastCompletionDate
    nextDueDate
    owner
    planId
    status
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTrainingEnrollmentMutationVariables,
  APITypes.DeleteTrainingEnrollmentMutation
>;
export const deleteTrainingPlan = /* GraphQL */ `mutation DeleteTrainingPlan(
  $condition: ModelTrainingPlanConditionInput
  $input: DeleteTrainingPlanInput!
) {
  deleteTrainingPlan(condition: $condition, input: $input) {
    categories
    companyId
    createdAt
    cycleDuration
    governingStandard
    holidays
    id
    minimumTimeRequired
    name
    owner
    startDate
    status
    updatedAt
    workingDays
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTrainingPlanMutationVariables,
  APITypes.DeleteTrainingPlanMutation
>;
export const deleteTrainingQuizResponse = /* GraphQL */ `mutation DeleteTrainingQuizResponse(
  $condition: ModelTrainingQuizResponseConditionInput
  $input: DeleteTrainingQuizResponseInput!
) {
  deleteTrainingQuizResponse(condition: $condition, input: $input) {
    attemptNumber
    categoryId
    companyId
    completedAt
    createdAt
    cycleStartDate
    formId
    id
    owner
    passed
    planId
    responseData
    score
    signaturePath
    totalQuestions
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTrainingQuizResponseMutationVariables,
  APITypes.DeleteTrainingQuizResponseMutation
>;
export const deleteTrainingSchedule = /* GraphQL */ `mutation DeleteTrainingSchedule(
  $condition: ModelTrainingScheduleConditionInput
  $input: DeleteTrainingScheduleInput!
) {
  deleteTrainingSchedule(condition: $condition, input: $input) {
    assignedUserId
    categoryId
    companyId
    createdAt
    dayNumber
    id
    locked
    owner
    planId
    scheduledDate
    topicId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTrainingScheduleMutationVariables,
  APITypes.DeleteTrainingScheduleMutation
>;
export const deleteTrainingTopic = /* GraphQL */ `mutation DeleteTrainingTopic(
  $condition: ModelTrainingTopicConditionInput
  $input: DeleteTrainingTopicInput!
) {
  deleteTrainingTopic(condition: $condition, input: $input) {
    categoryIds
    companyId
    companyResourceId
    contentFilePath
    contentUrl
    createdAt
    description
    id
    owner
    planIds
    style
    timeValue
    topicId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTrainingTopicMutationVariables,
  APITypes.DeleteTrainingTopicMutation
>;
export const deleteUnitExpenseBudget = /* GraphQL */ `mutation DeleteUnitExpenseBudget(
  $condition: ModelUnitExpenseBudgetConditionInput
  $input: DeleteUnitExpenseBudgetInput!
) {
  deleteUnitExpenseBudget(condition: $condition, input: $input) {
    companyId
    createdAt
    expenseCategoryId
    id
    owner
    startingBalance
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUnitExpenseBudgetMutationVariables,
  APITypes.DeleteUnitExpenseBudgetMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $condition: ModelUserConditionInput
  $input: DeleteUserInput!
) {
  deleteUser(condition: $condition, input: $input) {
    archived
    cognitoId
    companyId
    contactPhoneNumber
    contactPhoneType
    createdAt
    currentJobClassification
    dateOfHire
    discrepancyNotification
    discrepancyNotificationTypes
    domain
    driversLicenseStatus
    email
    globalLocationPermission
    id
    inputByPerson
    inputDate
    locationAssignment
    name
    notesAboutUser
    onHighwayEligibility
    owner
    permissions
    personalIdentification
    pmNotification
    pmNotificationTypes
    position
    regionalAssignment
    role
    safetyLessons
    skillTrackingModuleEnrollment
    trainingModuleEnrollment
    trainingNotification
    trainingNotificationTypes
    updatedAt
    userPhoto
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const deleteUserFile = /* GraphQL */ `mutation DeleteUserFile(
  $condition: ModelUserFileConditionInput
  $input: DeleteUserFileInput!
) {
  deleteUserFile(condition: $condition, input: $input) {
    companyId
    createdAt
    fileName
    fileSize
    id
    owner
    s3Path
    updatedAt
    uploadedAt
    uploadedBy
    uploadedByName
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserFileMutationVariables,
  APITypes.DeleteUserFileMutation
>;
export const deleteUserReportFavorite = /* GraphQL */ `mutation DeleteUserReportFavorite(
  $condition: ModelUserReportFavoriteConditionInput
  $input: DeleteUserReportFavoriteInput!
) {
  deleteUserReportFavorite(condition: $condition, input: $input) {
    companyId
    createdAt
    id
    reportTypeKey
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserReportFavoriteMutationVariables,
  APITypes.DeleteUserReportFavoriteMutation
>;
export const deleteUserSkillReport = /* GraphQL */ `mutation DeleteUserSkillReport(
  $condition: ModelUserSkillReportConditionInput
  $input: DeleteUserSkillReportInput!
) {
  deleteUserSkillReport(condition: $condition, input: $input) {
    assessorId
    assessorName
    companyId
    createdAt
    expirationDate
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    okCount
    passFailStatus
    photos
    qualificationLevel
    responseData
    signature
    skillCategory
    skillName
    totalItems
    updatedAt
    userId
    userName
    warnCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserSkillReportMutationVariables,
  APITypes.DeleteUserSkillReportMutation
>;
export const deleteVendorList = /* GraphQL */ `mutation DeleteVendorList(
  $condition: ModelVendorListConditionInput
  $input: DeleteVendorListInput!
) {
  deleteVendorList(condition: $condition, input: $input) {
    address
    companyId
    createdAt
    faxNumber
    id
    name
    owner
    phoneNumber
    repName
    repPhoneNumber
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteVendorListMutationVariables,
  APITypes.DeleteVendorListMutation
>;
export const deleteVideo = /* GraphQL */ `mutation DeleteVideo(
  $condition: ModelVideoConditionInput
  $input: DeleteVideoInput!
) {
  deleteVideo(condition: $condition, input: $input) {
    assignedSafetyLesson
    contentPath
    createdAt
    folderName
    id
    owner
    resourceLibraryID
    safetyLesson
    sharedWithCompanyIds
    title
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteVideoMutationVariables,
  APITypes.DeleteVideoMutation
>;
export const resendInvitation = /* GraphQL */ `mutation ResendInvitation($email: String!) {
  resendInvitation(email: $email)
}
` as GeneratedMutation<
  APITypes.ResendInvitationMutationVariables,
  APITypes.ResendInvitationMutation
>;
export const updateArchivedDiscrepancy = /* GraphQL */ `mutation UpdateArchivedDiscrepancy(
  $condition: ModelArchivedDiscrepancyConditionInput
  $input: UpdateArchivedDiscrepancyInput!
) {
  updateArchivedDiscrepancy(condition: $condition, input: $input) {
    archivedDate
    companyId
    createdAt
    downReason
    equipmentId
    equipmentName
    id
    initialStatus
    log
    owner
    promptDescription
    promptLabel
    promptTitle
    questionIndex
    reportId
    status
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateArchivedDiscrepancyMutationVariables,
  APITypes.UpdateArchivedDiscrepancyMutation
>;
export const updateAuditLog = /* GraphQL */ `mutation UpdateAuditLog(
  $condition: ModelAuditLogConditionInput
  $input: UpdateAuditLogInput!
) {
  updateAuditLog(condition: $condition, input: $input) {
    action
    companyId
    createdAt
    details
    id
    resourceId
    resourceName
    resourceType
    ttl
    updatedAt
    userId
    userName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAuditLogMutationVariables,
  APITypes.UpdateAuditLogMutation
>;
export const updateAxleBlueprint = /* GraphQL */ `mutation UpdateAxleBlueprint(
  $condition: ModelAxleBlueprintConditionInput
  $input: UpdateAxleBlueprintInput!
) {
  updateAxleBlueprint(condition: $condition, input: $input) {
    axles
    centerlineLength
    companyId
    createdAt
    description
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAxleBlueprintMutationVariables,
  APITypes.UpdateAxleBlueprintMutation
>;
export const updateBillingRate = /* GraphQL */ `mutation UpdateBillingRate(
  $condition: ModelBillingRateConditionInput
  $input: UpdateBillingRateInput!
) {
  updateBillingRate(condition: $condition, input: $input) {
    companyId
    createdAt
    id
    owner
    ratePerCostTracking
    ratePerEquipment
    ratePerPM
    ratePerSafetyEnrollment
    ratePerSkillQualification
    ratePerTireMaint
    ratePerUser
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBillingRateMutationVariables,
  APITypes.UpdateBillingRateMutation
>;
export const updateBusinessAdmin = /* GraphQL */ `mutation UpdateBusinessAdmin(
  $condition: ModelBusinessAdminConditionInput
  $input: UpdateBusinessAdminInput!
) {
  updateBusinessAdmin(condition: $condition, input: $input) {
    cognitoId
    createdAt
    domain
    email
    id
    name
    owner
    permissions
    role
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBusinessAdminMutationVariables,
  APITypes.UpdateBusinessAdminMutation
>;
export const updateChangeLogEntry = /* GraphQL */ `mutation UpdateChangeLogEntry(
  $condition: ModelChangeLogEntryConditionInput
  $input: UpdateChangeLogEntryInput!
) {
  updateChangeLogEntry(condition: $condition, input: $input) {
    changedBy
    changedByName
    companyId
    createdAt
    description
    fieldName
    id
    newValue
    oldValue
    owner
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateChangeLogEntryMutationVariables,
  APITypes.UpdateChangeLogEntryMutation
>;
export const updateClassification = /* GraphQL */ `mutation UpdateClassification(
  $condition: ModelClassificationConditionInput
  $input: UpdateClassificationInput!
) {
  updateClassification(condition: $condition, input: $input) {
    companyId
    createdAt
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateClassificationMutationVariables,
  APITypes.UpdateClassificationMutation
>;
export const updateCompany = /* GraphQL */ `mutation UpdateCompany(
  $condition: ModelCompanyConditionInput
  $input: UpdateCompanyInput!
) {
  updateCompany(condition: $condition, input: $input) {
    accountNumber
    accountOrigin
    accountStatus
    addOnGracePeriodEndDate
    archived
    assignedRep
    billingAnchorDay
    billingContactAddress
    billingContactEmail
    billingContactName
    billingContactPhone
    billingCycle
    businessType
    cancelEffectiveDate
    cancelReason
    cancelReasonNote
    cancelRequestedAt
    companyOwnerId
    coreMonthlyRate
    costTrackingModuleEnrollment
    createdAt
    dataRetentionEndDate
    description
    gracePeriodEndDate
    id
    industryNAICS
    industrySIC
    initialContactDate
    initialStarterPackageEnrollment
    logo
    maxNumberEquipment
    maxNumberUsers
    name
    nextBillingDate
    notes
    numberOfUsers
    paidStartDate
    paymentFailedAt
    paymentMethod
    pmModuleEnrollment
    primaryContactEmail
    primaryContactName
    primaryContactPhone
    primaryContactPosition
    primaryLocation
    referredBy
    retryAttempts
    safetyComplianceStandard
    secondaryContactEmail
    secondaryContactName
    secondaryContactPhone
    secondaryContactPosition
    skillTrackingModuleEnrollment
    starterPackage
    status
    subscriptionExpiration
    subscriptionType
    tiresModuleEnrollment
    trainingModuleEnrollment
    trialEndDate
    trialStartDate
    type
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCompanyMutationVariables,
  APITypes.UpdateCompanyMutation
>;
export const updateCompanyNote = /* GraphQL */ `mutation UpdateCompanyNote(
  $condition: ModelCompanyNoteConditionInput
  $input: UpdateCompanyNoteInput!
) {
  updateCompanyNote(condition: $condition, input: $input) {
    authorName
    companyId
    content
    createdAt
    id
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCompanyNoteMutationVariables,
  APITypes.UpdateCompanyNoteMutation
>;
export const updateCompanyOwner = /* GraphQL */ `mutation UpdateCompanyOwner(
  $condition: ModelCompanyOwnerConditionInput
  $input: UpdateCompanyOwnerInput!
) {
  updateCompanyOwner(condition: $condition, input: $input) {
    cognitoId
    companyId
    contactPhoneNumber
    createdAt
    discrepancyNotification
    discrepancyNotificationTypes
    domain
    email
    id
    name
    owner
    permissions
    pmNotification
    pmNotificationTypes
    role
    siteAdmin
    subscriptionType
    trainingNotification
    trainingNotificationTypes
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCompanyOwnerMutationVariables,
  APITypes.UpdateCompanyOwnerMutation
>;
export const updateCompanyResource = /* GraphQL */ `mutation UpdateCompanyResource(
  $condition: ModelCompanyResourceConditionInput
  $input: UpdateCompanyResourceInput!
) {
  updateCompanyResource(condition: $condition, input: $input) {
    category
    companyId
    contentFilePath
    contentUrl
    createdAt
    description
    fileType
    folderName
    id
    owner
    title
    trainingTopicId
    updatedAt
    uploadedByUserId
    uploadedByUserName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCompanyResourceMutationVariables,
  APITypes.UpdateCompanyResourceMutation
>;
export const updateDOTInspectionReport = /* GraphQL */ `mutation UpdateDOTInspectionReport(
  $condition: ModelDOTInspectionReportConditionInput
  $input: UpdateDOTInspectionReportInput!
) {
  updateDOTInspectionReport(condition: $condition, input: $input) {
    companyId
    complianceStatus
    createdAt
    dotInspectionType
    equipmentCategoryId
    equipmentCategoryName
    expirationDate
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    inspectorCertificationId
    locationId
    okCount
    photos
    regulatoryStandard
    responseData
    signature
    totalItems
    unitId
    unitName
    updatedAt
    userId
    userName
    vehicleLicensePlate
    vehicleVIN
    warnCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDOTInspectionReportMutationVariables,
  APITypes.UpdateDOTInspectionReportMutation
>;
export const updateDailyServiceReport = /* GraphQL */ `mutation UpdateDailyServiceReport(
  $condition: ModelDailyServiceReportConditionInput
  $input: UpdateDailyServiceReportInput!
) {
  updateDailyServiceReport(condition: $condition, input: $input) {
    companyId
    createdAt
    dailyServiceLogFormId
    equipmentCategoryId
    equipmentCategoryName
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    locationId
    machineHoursAtService
    okCount
    photos
    responseData
    signature
    totalItems
    umCounterAtService
    unitId
    unitName
    updatedAt
    userId
    userName
    warnCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDailyServiceReportMutationVariables,
  APITypes.UpdateDailyServiceReportMutation
>;
export const updateDiscrepancy = /* GraphQL */ `mutation UpdateDiscrepancy(
  $condition: ModelDiscrepancyConditionInput
  $input: UpdateDiscrepancyInput!
) {
  updateDiscrepancy(condition: $condition, input: $input) {
    companyId
    createdAt
    downReason
    equipmentId
    equipmentName
    id
    initialStatus
    log
    owner
    promptDescription
    promptLabel
    promptTitle
    questionIndex
    reportId
    status
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDiscrepancyMutationVariables,
  APITypes.UpdateDiscrepancyMutation
>;
export const updateDocument = /* GraphQL */ `mutation UpdateDocument(
  $condition: ModelDocumentConditionInput
  $input: UpdateDocumentInput!
) {
  updateDocument(condition: $condition, input: $input) {
    assignedSafetyLesson
    contentPath
    createdAt
    folderName
    id
    owner
    resourceLibraryID
    safetyLesson
    sharedWithCompanyIds
    title
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDocumentMutationVariables,
  APITypes.UpdateDocumentMutation
>;
export const updateEquipment = /* GraphQL */ `mutation UpdateEquipment(
  $condition: ModelEquipmentConditionInput
  $input: UpdateEquipmentInput!
) {
  updateEquipment(condition: $condition, input: $input) {
    companyId
    createdAt
    formId
    id
    image
    name
    units
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEquipmentMutationVariables,
  APITypes.UpdateEquipmentMutation
>;
export const updateEquipmentCategory = /* GraphQL */ `mutation UpdateEquipmentCategory(
  $condition: ModelEquipmentCategoryConditionInput
  $input: UpdateEquipmentCategoryInput!
) {
  updateEquipmentCategory(condition: $condition, input: $input) {
    companyId
    createdAt
    formId
    id
    image
    name
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEquipmentCategoryMutationVariables,
  APITypes.UpdateEquipmentCategoryMutation
>;
export const updateErrors = /* GraphQL */ `mutation UpdateErrors(
  $condition: ModelErrorsConditionInput
  $input: UpdateErrorsInput!
) {
  updateErrors(condition: $condition, input: $input) {
    createdAt
    errors
    id
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateErrorsMutationVariables,
  APITypes.UpdateErrorsMutation
>;
export const updateExpenseCategory = /* GraphQL */ `mutation UpdateExpenseCategory(
  $condition: ModelExpenseCategoryConditionInput
  $input: UpdateExpenseCategoryInput!
) {
  updateExpenseCategory(condition: $condition, input: $input) {
    companyId
    createdAt
    id
    name
    owner
    startingBalance
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateExpenseCategoryMutationVariables,
  APITypes.UpdateExpenseCategoryMutation
>;
export const updateExpenseRecord = /* GraphQL */ `mutation UpdateExpenseRecord(
  $condition: ModelExpenseRecordConditionInput
  $input: UpdateExpenseRecordInput!
) {
  updateExpenseRecord(condition: $condition, input: $input) {
    attachments
    companyId
    createdAt
    dateOfInput
    dateOfService
    equipmentCategoryId
    expenseCategories
    id
    invoiceNumber
    laborHoursOT
    laborHoursST
    laborRateOT
    laborRateST
    laborRateScheduleId
    laborRateScheduleName
    owner
    pmExpense
    pmServiceLevelId
    pmServiceLevelName
    totalExpense
    totalLaborCost
    unitId
    updatedAt
    vendorId
    vendorName
    workDescription
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateExpenseRecordMutationVariables,
  APITypes.UpdateExpenseRecordMutation
>;
export const updateForm = /* GraphQL */ `mutation UpdateForm(
  $condition: ModelFormConditionInput
  $input: UpdateFormInput!
) {
  updateForm(condition: $condition, input: $input) {
    alwaysTriggerEmail
    companyId
    createdAt
    dailyServiceLogForm
    equipmentType
    formData
    formType
    id
    inspectionForm
    name
    noMachineHours
    noUMCounter
    owner
    pmServiceScheduleForm
    status
    umCounterLabel
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFormMutationVariables,
  APITypes.UpdateFormMutation
>;
export const updateFormTemplate = /* GraphQL */ `mutation UpdateFormTemplate(
  $condition: ModelFormTemplateConditionInput
  $input: UpdateFormTemplateInput!
) {
  updateFormTemplate(condition: $condition, input: $input) {
    createdAt
    createdByCompanyOwnerId
    dailyServiceLogForm
    formTemplateGroupID
    id
    inspectionForm
    originalCompanyId
    owner
    pmServiceScheduleForm
    templateData
    templateName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFormTemplateMutationVariables,
  APITypes.UpdateFormTemplateMutation
>;
export const updateFormTemplateGroup = /* GraphQL */ `mutation UpdateFormTemplateGroup(
  $condition: ModelFormTemplateGroupConditionInput
  $input: UpdateFormTemplateGroupInput!
) {
  updateFormTemplateGroup(condition: $condition, input: $input) {
    createdAt
    description
    id
    name
    owner
    resourceLibraryID
    sharedWithCompanyIds
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFormTemplateGroupMutationVariables,
  APITypes.UpdateFormTemplateGroupMutation
>;
export const updateHelpSupportDoc = /* GraphQL */ `mutation UpdateHelpSupportDoc(
  $condition: ModelHelpSupportDocConditionInput
  $input: UpdateHelpSupportDocInput!
) {
  updateHelpSupportDoc(condition: $condition, input: $input) {
    contentFilePath
    contentUrl
    createdAt
    createdByAdminId
    description
    docType
    id
    owner
    sharedWithCompanyIds
    status
    title
    updatedAt
    visibility
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateHelpSupportDocMutationVariables,
  APITypes.UpdateHelpSupportDocMutation
>;
export const updateInspectionReport = /* GraphQL */ `mutation UpdateInspectionReport(
  $condition: ModelInspectionReportConditionInput
  $input: UpdateInspectionReportInput!
) {
  updateInspectionReport(condition: $condition, input: $input) {
    alwaysTriggerEmail
    companyId
    createdAt
    equipmentCategoryId
    equipmentCategoryName
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    locationId
    machineHoursAtInspection
    okCount
    photos
    responseData
    signature
    totalItems
    umCounterAtInspection
    unitId
    unitName
    updatedAt
    userId
    userName
    warnCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateInspectionReportMutationVariables,
  APITypes.UpdateInspectionReportMutation
>;
export const updateInvoice = /* GraphQL */ `mutation UpdateInvoice(
  $condition: ModelInvoiceConditionInput
  $input: UpdateInvoiceInput!
) {
  updateInvoice(condition: $condition, input: $input) {
    amount
    companyId
    createdAt
    date
    description
    id
    invoiceNumber
    lineItems
    owner
    pdfUrl
    status
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateInvoiceMutationVariables,
  APITypes.UpdateInvoiceMutation
>;
export const updateLaborCategory = /* GraphQL */ `mutation UpdateLaborCategory(
  $condition: ModelLaborCategoryConditionInput
  $input: UpdateLaborCategoryInput!
) {
  updateLaborCategory(condition: $condition, input: $input) {
    companyId
    createdAt
    id
    isActive
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLaborCategoryMutationVariables,
  APITypes.UpdateLaborCategoryMutation
>;
export const updateLaborRate = /* GraphQL */ `mutation UpdateLaborRate(
  $condition: ModelLaborRateConditionInput
  $input: UpdateLaborRateInput!
) {
  updateLaborRate(condition: $condition, input: $input) {
    categoryId
    createdAt
    effectiveDate
    id
    overtimeRate
    owner
    standardRate
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLaborRateMutationVariables,
  APITypes.UpdateLaborRateMutation
>;
export const updateLibraryPlanTemplate = /* GraphQL */ `mutation UpdateLibraryPlanTemplate(
  $condition: ModelLibraryPlanTemplateConditionInput
  $input: UpdateLibraryPlanTemplateInput!
) {
  updateLibraryPlanTemplate(condition: $condition, input: $input) {
    categories
    categoryCount
    createdAt
    createdByAdminId
    createdByAdminName
    cycleDuration
    description
    governingStandard
    id
    minimumTimeRequired
    name
    owner
    sharedWithCompanyIds
    status
    topicCount
    updatedAt
    workingDays
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLibraryPlanTemplateMutationVariables,
  APITypes.UpdateLibraryPlanTemplateMutation
>;
export const updateLibraryTopicTemplate = /* GraphQL */ `mutation UpdateLibraryTopicTemplate(
  $condition: ModelLibraryTopicTemplateConditionInput
  $input: UpdateLibraryTopicTemplateInput!
) {
  updateLibraryTopicTemplate(condition: $condition, input: $input) {
    contentFilePath
    contentUrl
    createdAt
    createdByAdminId
    description
    id
    owner
    style
    timeValue
    topicId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLibraryTopicTemplateMutationVariables,
  APITypes.UpdateLibraryTopicTemplateMutation
>;
export const updateLocation = /* GraphQL */ `mutation UpdateLocation(
  $condition: ModelLocationConditionInput
  $input: UpdateLocationInput!
) {
  updateLocation(condition: $condition, input: $input) {
    companyId
    createdAt
    description
    id
    name
    owner
    regionalDivisionId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLocationMutationVariables,
  APITypes.UpdateLocationMutation
>;
export const updateModuleSubscription = /* GraphQL */ `mutation UpdateModuleSubscription(
  $condition: ModelModuleSubscriptionConditionInput
  $input: UpdateModuleSubscriptionInput!
) {
  updateModuleSubscription(condition: $condition, input: $input) {
    activatedAt
    cancelRequestedAt
    companyId
    createdAt
    effectiveEndDate
    id
    moduleKey
    monthlyRate
    owner
    pricingModel
    status
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateModuleSubscriptionMutationVariables,
  APITypes.UpdateModuleSubscriptionMutation
>;
export const updatePMConfiguration = /* GraphQL */ `mutation UpdatePMConfiguration(
  $condition: ModelPMConfigurationConditionInput
  $input: UpdatePMConfigurationInput!
) {
  updatePMConfiguration(condition: $condition, input: $input) {
    companyId
    createdAt
    dueSoonPercentage
    id
    laborCategoryId
    owner
    unitId
    unitOfMeasure
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePMConfigurationMutationVariables,
  APITypes.UpdatePMConfigurationMutation
>;
export const updatePMModuleContent = /* GraphQL */ `mutation UpdatePMModuleContent(
  $condition: ModelPMModuleContentConditionInput
  $input: UpdatePMModuleContentInput!
) {
  updatePMModuleContent(condition: $condition, input: $input) {
    createdAt
    id
    owner
    pmServiceFormId
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePMModuleContentMutationVariables,
  APITypes.UpdatePMModuleContentMutation
>;
export const updatePMNotificationSetting = /* GraphQL */ `mutation UpdatePMNotificationSetting(
  $condition: ModelPMNotificationSettingConditionInput
  $input: UpdatePMNotificationSettingInput!
) {
  updatePMNotificationSetting(condition: $condition, input: $input) {
    createdAt
    emailThresholdUM
    id
    lastNotificationSent
    notificationFrequency
    owner
    pmConfigurationId
    recipients
    serviceLevelId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePMNotificationSettingMutationVariables,
  APITypes.UpdatePMNotificationSettingMutation
>;
export const updatePMPartsAndProcedure = /* GraphQL */ `mutation UpdatePMPartsAndProcedure(
  $condition: ModelPMPartsAndProcedureConditionInput
  $input: UpdatePMPartsAndProcedureInput!
) {
  updatePMPartsAndProcedure(condition: $condition, input: $input) {
    category
    companyId
    createdAt
    createdByUserId
    createdByUserName
    id
    itemName
    itemType
    manufacturer
    owner
    partNumber
    pmConfigurationId
    pmConfigurationIds
    price
    quantity
    sortOrder
    unitOfMeasure
    updatedAt
    vendorId
    vendorName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePMPartsAndProcedureMutationVariables,
  APITypes.UpdatePMPartsAndProcedureMutation
>;
export const updatePMReport = /* GraphQL */ `mutation UpdatePMReport(
  $condition: ModelPMReportConditionInput
  $input: UpdatePMReportInput!
) {
  updatePMReport(condition: $condition, input: $input) {
    actualUM
    companyId
    createdAt
    id
    issueDescription
    issueTicketCreated
    issueTicketId
    laborHoursOT
    laborHoursST
    laborRateOT
    laborRateST
    laborRateScheduleId
    laborRateScheduleName
    owner
    photos
    pmConfigurationId
    reportData
    serviceDate
    serviceLevelId
    serviceLevelName
    signature
    status
    technicianId
    technicianName
    totalLaborCost
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePMReportMutationVariables,
  APITypes.UpdatePMReportMutation
>;
export const updatePMServiceLevel = /* GraphQL */ `mutation UpdatePMServiceLevel(
  $condition: ModelPMServiceLevelConditionInput
  $input: UpdatePMServiceLevelInput!
) {
  updatePMServiceLevel(condition: $condition, input: $input) {
    createdAt
    description
    id
    intervalValue
    lastServiceDate
    lastServiceUM
    levelIdentifier
    owner
    pmConfigurationId
    pmServiceFormId
    serviceLevelAssignments
    targetUM
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePMServiceLevelMutationVariables,
  APITypes.UpdatePMServiceLevelMutation
>;
export const updateRegionalDivision = /* GraphQL */ `mutation UpdateRegionalDivision(
  $condition: ModelRegionalDivisionConditionInput
  $input: UpdateRegionalDivisionInput!
) {
  updateRegionalDivision(condition: $condition, input: $input) {
    companyId
    createdAt
    description
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRegionalDivisionMutationVariables,
  APITypes.UpdateRegionalDivisionMutation
>;
export const updateReport = /* GraphQL */ `mutation UpdateReport(
  $condition: ModelReportConditionInput
  $input: UpdateReportInput!
) {
  updateReport(condition: $condition, input: $input) {
    alwaysTriggerEmail
    companyId
    createdAt
    dailyServiceLogReport
    equipmentId
    equipmentLocationId
    equipmentName
    id
    inspectionCompleted
    inspectionStarted
    name
    signature
    unitId
    unitName
    updatedAt
    userData
    userId
    userLocation
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReportMutationVariables,
  APITypes.UpdateReportMutation
>;
export const updateReportAnswer = /* GraphQL */ `mutation UpdateReportAnswer(
  $condition: ModelReportAnswerConditionInput
  $input: UpdateReportAnswerInput!
) {
  updateReportAnswer(condition: $condition, input: $input) {
    companyId
    createdAt
    id
    notes
    parentReportId
    photos
    promptDescription
    promptKey
    promptLabel
    promptTitle
    promptType
    reportType
    sortOrder
    unitId
    updatedAt
    value
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReportAnswerMutationVariables,
  APITypes.UpdateReportAnswerMutation
>;
export const updateResourceLibrary = /* GraphQL */ `mutation UpdateResourceLibrary(
  $condition: ModelResourceLibraryConditionInput
  $input: UpdateResourceLibraryInput!
) {
  updateResourceLibrary(condition: $condition, input: $input) {
    companyOwnerId
    createdAt
    id
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateResourceLibraryMutationVariables,
  APITypes.UpdateResourceLibraryMutation
>;
export const updateSavedReportConfiguration = /* GraphQL */ `mutation UpdateSavedReportConfiguration(
  $condition: ModelSavedReportConfigurationConditionInput
  $input: UpdateSavedReportConfigurationInput!
) {
  updateSavedReportConfiguration(condition: $condition, input: $input) {
    companyId
    compareDateRangeEnd
    compareDateRangeStart
    createdAt
    dateRangeEnd
    dateRangeStart
    dateRangeType
    filtersJson
    groupByField
    id
    lastRunAt
    metricCategory
    metricKey
    reportName
    updatedAt
    userId
    visualizationType
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSavedReportConfigurationMutationVariables,
  APITypes.UpdateSavedReportConfigurationMutation
>;
export const updateSensitiveUserInfo = /* GraphQL */ `mutation UpdateSensitiveUserInfo(
  $condition: ModelSensitiveUserInfoConditionInput
  $input: UpdateSensitiveUserInfoInput!
) {
  updateSensitiveUserInfo(condition: $condition, input: $input) {
    cognitoId
    companyId
    createdAt
    dateOfBirth
    driversLicenseClass
    driversLicenseExpirationDate
    driversLicenseNumber
    driversLicenseState
    emergencyContactName
    emergencyContactPhoneNumber
    emergencyContactRelationship
    id
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSensitiveUserInfoMutationVariables,
  APITypes.UpdateSensitiveUserInfoMutation
>;
export const updateShiftReport = /* GraphQL */ `mutation UpdateShiftReport(
  $condition: ModelShiftReportConditionInput
  $input: UpdateShiftReportInput!
) {
  updateShiftReport(condition: $condition, input: $input) {
    alwaysTriggerEmail
    companyId
    createdAt
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    locationId
    locationName
    okCount
    photos
    responseData
    shiftType
    signature
    totalItems
    updatedAt
    userId
    userName
    warnCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateShiftReportMutationVariables,
  APITypes.UpdateShiftReportMutation
>;
export const updateSingleUnit = /* GraphQL */ `mutation UpdateSingleUnit(
  $condition: ModelSingleUnitConditionInput
  $input: UpdateSingleUnitInput!
) {
  updateSingleUnit(condition: $condition, input: $input) {
    annualProjectedUsage
    aquisitionCost
    aquisitionDate
    assignedTo
    axleConfiguration
    categoryId
    costTrackingModuleEnrollment
    createdAt
    currentMachineHours
    currentUMCounterValue
    dailyServiceLogFormId
    description
    dispositionDate
    dispositionReason
    downReason
    engineManufacturer
    engineModelNumber
    equipmentStatus
    extraUnitInfo
    id
    image
    inputByPerson
    inputDate
    lastDailyServiceDate
    lastInspectionDate
    lastServiceHours
    licenseNumber
    locationId
    machineHoursAtAquisition
    machineUMCounterAtAquisition
    manufactureDate
    manufacturerName
    modelNumber
    name
    pmModuleEnrollment
    putInServiceDate
    removedFromServiceDate
    removedFromServiceReason
    replacedUMCounterHistory
    replacedUMCounterStatus
    replacedUMCounterValue
    serialNumber
    tiresModuleEnrollment
    unitOfMeasure
    updatedAt
    utilizationAdjustmentDays
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSingleUnitMutationVariables,
  APITypes.UpdateSingleUnitMutation
>;
export const updateSkillAssignment = /* GraphQL */ `mutation UpdateSkillAssignment(
  $condition: ModelSkillAssignmentConditionInput
  $input: UpdateSkillAssignmentInput!
) {
  updateSkillAssignment(condition: $condition, input: $input) {
    companyId
    createdAt
    evaluatedBy
    evaluatedByName
    evaluationDate
    id
    owner
    skillLevel
    subCategoryId
    taskId
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSkillAssignmentMutationVariables,
  APITypes.UpdateSkillAssignmentMutation
>;
export const updateSkillCategory = /* GraphQL */ `mutation UpdateSkillCategory(
  $condition: ModelSkillCategoryConditionInput
  $input: UpdateSkillCategoryInput!
) {
  updateSkillCategory(condition: $condition, input: $input) {
    allowMachineNumber
    classificationId
    companyId
    createdAt
    equipmentCategoryId
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSkillCategoryMutationVariables,
  APITypes.UpdateSkillCategoryMutation
>;
export const updateSkillLevel = /* GraphQL */ `mutation UpdateSkillLevel(
  $condition: ModelSkillLevelConditionInput
  $input: UpdateSkillLevelInput!
) {
  updateSkillLevel(condition: $condition, input: $input) {
    color
    companyId
    createdAt
    description
    id
    name
    owner
    sortOrder
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSkillLevelMutationVariables,
  APITypes.UpdateSkillLevelMutation
>;
export const updateSkillTask = /* GraphQL */ `mutation UpdateSkillTask(
  $condition: ModelSkillTaskConditionInput
  $input: UpdateSkillTaskInput!
) {
  updateSkillTask(condition: $condition, input: $input) {
    categoryId
    companyId
    createdAt
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSkillTaskMutationVariables,
  APITypes.UpdateSkillTaskMutation
>;
export const updateSubCategory = /* GraphQL */ `mutation UpdateSubCategory(
  $condition: ModelSubCategoryConditionInput
  $input: UpdateSubCategoryInput!
) {
  updateSubCategory(condition: $condition, input: $input) {
    categoryId
    companyId
    createdAt
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSubCategoryMutationVariables,
  APITypes.UpdateSubCategoryMutation
>;
export const updateTire = /* GraphQL */ `mutation UpdateTire(
  $condition: ModelTireConditionInput
  $input: UpdateTireInput!
) {
  updateTire(condition: $condition, input: $input) {
    assignedAxle
    assignedPosition
    companyId
    createdAt
    currentTirePressure
    currentTreadDepth
    dateInstalled
    dateUninstalled
    failureReason
    id
    inflationMedium
    loadRating
    loadRatingUnit
    minimumTreadDepth
    name
    owner
    recommendedTirePressure
    removedFromService
    removedFromServiceDate
    tireCategory
    tireManufacturer
    tireModel
    tireSize
    tireStatus
    treadDepthAtInstall
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTireMutationVariables,
  APITypes.UpdateTireMutation
>;
export const updateTireReport = /* GraphQL */ `mutation UpdateTireReport(
  $condition: ModelTireReportConditionInput
  $input: UpdateTireReportInput!
) {
  updateTireReport(condition: $condition, input: $input) {
    alwaysTriggerEmail
    companyId
    createdAt
    equipmentCategoryId
    equipmentCategoryName
    equipmentLocationId
    id
    inspectionCompleted
    inspectionStarted
    name
    signature
    tireId
    unitId
    unitName
    updatedAt
    userData
    userId
    userLocation
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTireReportMutationVariables,
  APITypes.UpdateTireReportMutation
>;
export const updateTrainingAffidavit = /* GraphQL */ `mutation UpdateTrainingAffidavit(
  $condition: ModelTrainingAffidavitConditionInput
  $input: UpdateTrainingAffidavitInput!
) {
  updateTrainingAffidavit(condition: $condition, input: $input) {
    adminId
    affidavitDate
    companyId
    createdAt
    id
    legalText
    nextDueDate
    owner
    planId
    signaturePath
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTrainingAffidavitMutationVariables,
  APITypes.UpdateTrainingAffidavitMutation
>;
export const updateTrainingCompletion = /* GraphQL */ `mutation UpdateTrainingCompletion(
  $condition: ModelTrainingCompletionConditionInput
  $input: UpdateTrainingCompletionInput!
) {
  updateTrainingCompletion(condition: $condition, input: $input) {
    categoryId
    companyId
    completionDate
    createdAt
    id
    launched
    markedAsViewed
    owner
    planId
    scheduleDate
    signaturePath
    timeValueMinutes
    topicId
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTrainingCompletionMutationVariables,
  APITypes.UpdateTrainingCompletionMutation
>;
export const updateTrainingEnrollment = /* GraphQL */ `mutation UpdateTrainingEnrollment(
  $condition: ModelTrainingEnrollmentConditionInput
  $input: UpdateTrainingEnrollmentInput!
) {
  updateTrainingEnrollment(condition: $condition, input: $input) {
    companyId
    createdAt
    enrolledDate
    id
    lastCompletionDate
    nextDueDate
    owner
    planId
    status
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTrainingEnrollmentMutationVariables,
  APITypes.UpdateTrainingEnrollmentMutation
>;
export const updateTrainingPlan = /* GraphQL */ `mutation UpdateTrainingPlan(
  $condition: ModelTrainingPlanConditionInput
  $input: UpdateTrainingPlanInput!
) {
  updateTrainingPlan(condition: $condition, input: $input) {
    categories
    companyId
    createdAt
    cycleDuration
    governingStandard
    holidays
    id
    minimumTimeRequired
    name
    owner
    startDate
    status
    updatedAt
    workingDays
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTrainingPlanMutationVariables,
  APITypes.UpdateTrainingPlanMutation
>;
export const updateTrainingQuizResponse = /* GraphQL */ `mutation UpdateTrainingQuizResponse(
  $condition: ModelTrainingQuizResponseConditionInput
  $input: UpdateTrainingQuizResponseInput!
) {
  updateTrainingQuizResponse(condition: $condition, input: $input) {
    attemptNumber
    categoryId
    companyId
    completedAt
    createdAt
    cycleStartDate
    formId
    id
    owner
    passed
    planId
    responseData
    score
    signaturePath
    totalQuestions
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTrainingQuizResponseMutationVariables,
  APITypes.UpdateTrainingQuizResponseMutation
>;
export const updateTrainingSchedule = /* GraphQL */ `mutation UpdateTrainingSchedule(
  $condition: ModelTrainingScheduleConditionInput
  $input: UpdateTrainingScheduleInput!
) {
  updateTrainingSchedule(condition: $condition, input: $input) {
    assignedUserId
    categoryId
    companyId
    createdAt
    dayNumber
    id
    locked
    owner
    planId
    scheduledDate
    topicId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTrainingScheduleMutationVariables,
  APITypes.UpdateTrainingScheduleMutation
>;
export const updateTrainingTopic = /* GraphQL */ `mutation UpdateTrainingTopic(
  $condition: ModelTrainingTopicConditionInput
  $input: UpdateTrainingTopicInput!
) {
  updateTrainingTopic(condition: $condition, input: $input) {
    categoryIds
    companyId
    companyResourceId
    contentFilePath
    contentUrl
    createdAt
    description
    id
    owner
    planIds
    style
    timeValue
    topicId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTrainingTopicMutationVariables,
  APITypes.UpdateTrainingTopicMutation
>;
export const updateUnitExpenseBudget = /* GraphQL */ `mutation UpdateUnitExpenseBudget(
  $condition: ModelUnitExpenseBudgetConditionInput
  $input: UpdateUnitExpenseBudgetInput!
) {
  updateUnitExpenseBudget(condition: $condition, input: $input) {
    companyId
    createdAt
    expenseCategoryId
    id
    owner
    startingBalance
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUnitExpenseBudgetMutationVariables,
  APITypes.UpdateUnitExpenseBudgetMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $condition: ModelUserConditionInput
  $input: UpdateUserInput!
) {
  updateUser(condition: $condition, input: $input) {
    archived
    cognitoId
    companyId
    contactPhoneNumber
    contactPhoneType
    createdAt
    currentJobClassification
    dateOfHire
    discrepancyNotification
    discrepancyNotificationTypes
    domain
    driversLicenseStatus
    email
    globalLocationPermission
    id
    inputByPerson
    inputDate
    locationAssignment
    name
    notesAboutUser
    onHighwayEligibility
    owner
    permissions
    personalIdentification
    pmNotification
    pmNotificationTypes
    position
    regionalAssignment
    role
    safetyLessons
    skillTrackingModuleEnrollment
    trainingModuleEnrollment
    trainingNotification
    trainingNotificationTypes
    updatedAt
    userPhoto
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const updateUserFile = /* GraphQL */ `mutation UpdateUserFile(
  $condition: ModelUserFileConditionInput
  $input: UpdateUserFileInput!
) {
  updateUserFile(condition: $condition, input: $input) {
    companyId
    createdAt
    fileName
    fileSize
    id
    owner
    s3Path
    updatedAt
    uploadedAt
    uploadedBy
    uploadedByName
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserFileMutationVariables,
  APITypes.UpdateUserFileMutation
>;
export const updateUserReportFavorite = /* GraphQL */ `mutation UpdateUserReportFavorite(
  $condition: ModelUserReportFavoriteConditionInput
  $input: UpdateUserReportFavoriteInput!
) {
  updateUserReportFavorite(condition: $condition, input: $input) {
    companyId
    createdAt
    id
    reportTypeKey
    updatedAt
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserReportFavoriteMutationVariables,
  APITypes.UpdateUserReportFavoriteMutation
>;
export const updateUserSkillReport = /* GraphQL */ `mutation UpdateUserSkillReport(
  $condition: ModelUserSkillReportConditionInput
  $input: UpdateUserSkillReportInput!
) {
  updateUserSkillReport(condition: $condition, input: $input) {
    assessorId
    assessorName
    companyId
    createdAt
    expirationDate
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    okCount
    passFailStatus
    photos
    qualificationLevel
    responseData
    signature
    skillCategory
    skillName
    totalItems
    updatedAt
    userId
    userName
    warnCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserSkillReportMutationVariables,
  APITypes.UpdateUserSkillReportMutation
>;
export const updateVendorList = /* GraphQL */ `mutation UpdateVendorList(
  $condition: ModelVendorListConditionInput
  $input: UpdateVendorListInput!
) {
  updateVendorList(condition: $condition, input: $input) {
    address
    companyId
    createdAt
    faxNumber
    id
    name
    owner
    phoneNumber
    repName
    repPhoneNumber
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateVendorListMutationVariables,
  APITypes.UpdateVendorListMutation
>;
export const updateVideo = /* GraphQL */ `mutation UpdateVideo(
  $condition: ModelVideoConditionInput
  $input: UpdateVideoInput!
) {
  updateVideo(condition: $condition, input: $input) {
    assignedSafetyLesson
    contentPath
    createdAt
    folderName
    id
    owner
    resourceLibraryID
    safetyLesson
    sharedWithCompanyIds
    title
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateVideoMutationVariables,
  APITypes.UpdateVideoMutation
>;
